// import React, { useState, useEffect, useRef } from 'react';
// import { Link } from 'react-router-dom';
// import { 
//   Building2, 
//   MapPin, 
//   Download, 
//   CheckCircle, 
//   Home,
//   TreePine,
//   Shield,
//   Phone,
//   Mail,
//   ArrowRight,
//   ChevronDown,
//   Star,
//   TrendingUp,
//   Users,
//   Award,
//   ExternalLink,
//   Droplets,
//   Zap,
//   Ruler,
//   Lock,
//   ParkingCircle,
//   Activity
// } from 'lucide-react';

// const MaaGarudadriPage = () => {
//   const [scrolled, setScrolled] = useState(false);
//   const scrollContainerRef = useRef(null);

//   useEffect(() => {
//     const handleScroll = () => {
//       setScrolled(window.scrollY > 50);
//     };
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   // Auto-scroll gallery
//   useEffect(() => {
//     const container = scrollContainerRef.current;
//     if (!container) return;

//     let scrollAmount = 0;
//     const scrollStep = 1;
//     const scrollInterval = 30;

//     const autoScroll = setInterval(() => {
//       if (container.scrollLeft >= container.scrollWidth - container.clientWidth) {
//         container.scrollLeft = 0;
//         scrollAmount = 0;
//       } else {
//         container.scrollLeft += scrollStep;
//         scrollAmount += scrollStep;
//       }
//     }, scrollInterval);

//     return () => clearInterval(autoScroll);
//   }, []);

//   const highlights = [
//     { icon: <Home className="w-6 h-6" />, title: 'Villa Plots', subtitle: 'Premium Layouts' },
//     { icon: <MapPin className="w-6 h-6" />, title: 'Dandupally', subtitle: 'Nagpur Highway' },
//     { icon: <Building2 className="w-6 h-6" />, title: 'Vastu Compliant', subtitle: 'Perfect Design' },
//     { icon: <Star className="w-6 h-6" />, title: 'Value-Driven', subtitle: 'Competitive Price' }
//   ];

//   const galleryImages = [
//     'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=800',
//     'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800',
//     'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800',
//     'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=800',
//     'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800',
//     'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=800',
//     'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800',
//     'https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=800'
//   ];

//   const features = [
//     {
//       icon: <Ruler className="w-8 h-8" />,
//       title: 'Vastu-Compliant Layouts',
//       desc: 'Ensuring harmony and prosperity in every plot'
//     },
//     {
//       icon: <ParkingCircle className="w-8 h-8" />,
//       title: 'Wide Roads',
//       desc: 'Modern infrastructure with 40-60 feet roads'
//     },
//     {
//       icon: <Zap className="w-8 h-8" />,
//       title: 'Underground Utilities',
//       desc: 'Power supply and drainage systems'
//     },
//     {
//       icon: <TreePine className="w-8 h-8" />,
//       title: 'Ample Green Spaces',
//       desc: 'Landscaped parks and gardens'
//     },
//     {
//       icon: <Shield className="w-8 h-8" />,
//       title: '24/7 Security',
//       desc: 'Secure gated community with CCTV'
//     },
//     {
//       icon: <Droplets className="w-8 h-8" />,
//       title: 'Rainwater Harvesting',
//       desc: 'Environmentally conscious development'
//     },
//     {
//       icon: <Activity className="w-8 h-8" />,
//       title: 'Fitness Zones',
//       desc: 'Jogging tracks and outdoor gym'
//     },
//     {
//       icon: <Lock className="w-8 h-8" />,
//       title: 'Gated Community',
//       desc: 'Complete peace of mind for residents'
//     }
//   ];

//   const connectivity = [
//     'Close proximity to Outer Ring Road (ORR)',
//     'Easy commute to IT hubs like Gachibowli & HITEC City',
//     'Well-connected to Rajiv Gandhi International Airport',
//     'Near Pharma City & Aerospace SEZ',
//     'Educational institutions within reach',
//     'Hospitals and healthcare facilities nearby',
//     'Shopping centers and malls accessible',
//     'Excellent public transport connectivity'
//   ];

//   const advantages = [
//     {
//       icon: <TrendingUp className="w-10 h-10" />,
//       title: 'Strategic Growth Corridor',
//       desc: 'Connects Hyderabad to major cities, making it ideal for residential and commercial developments'
//     },
//     {
//       icon: <Building2 className="w-10 h-10" />,
//       title: 'Infrastructure Boom',
//       desc: 'Government focus on industrial corridors, logistics hubs, and upgraded roads'
//     },
//     {
//       icon: <Award className="w-10 h-10" />,
//       title: 'Future-Ready Location',
//       desc: "Dandupally's strategic location ensures high returns on investment"
//     },
//     {
//       icon: <Users className="w-10 h-10" />,
//       title: 'Planned Community Living',
//       desc: 'Landscaped parks, fitness zones, and modern amenities for comfortable living'
//     }
//   ];

//   const whyVedamsa = [
//     { number: '30+', text: 'Years of Experience' },
//     { number: '3000+', text: 'Satisfied Customers' },
//     { number: '100%', text: 'Quality Commitment' },
//     { number: '100%', text: 'Transparent Practices' }
//   ];

//   return (
//     <div className="min-h-screen bg-[#f5f3f0]">
//       {/* Hero Section */}
//       <section className="relative h-screen w-full overflow-hidden">
//         {/* Background Image */}
//         <div 
//           className="absolute inset-0 bg-cover bg-center"
//           style={{
//             backgroundImage: `url('https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=1920')`,
//           }}
//         ></div>
        
//         {/* Gradient Overlay */}
//         <div className="absolute inset-0 bg-gradient-to-br from-[#2C5F2D]/90 via-[#4A7C59]/70 to-transparent"></div>

//         {/* Hero Content */}
//         <div className="relative z-20 h-full flex items-center">
//           <div className="max-w-7xl mx-auto px-6 w-full">
//             <div className="max-w-3xl">
//               {/* Badge */}
//               <div className="inline-block mb-6 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-6 py-2">
//                 <span className="text-white text-sm font-medium">By Vedamsa - 30 Years of Excellence</span>
//               </div>

//               {/* Main Heading */}
//               <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
//                 MAA Garudadri
//               </h1>
              
//               <p className="text-2xl md:text-3xl text-white/90 mb-4 font-light">
//                 Premium Villa Plots
//               </p>
              
//               <p className="text-xl text-white/80 mb-8">
//                 Dandupally, Nagpur Highway (NH-44)
//               </p>

//               {/* Key Feature Badge */}
//               <div className="inline-block bg-white rounded-2xl px-8 py-4 mb-10 shadow-2xl">
//                 <p className="text-gray-600 text-sm mb-1">Northern Growth Corridor</p>
//                 <p className="text-2xl font-bold text-[#2C5F2D]">Hyderabad's Prime Location</p>
//               </div>

//               {/* CTA Buttons */}
//               <div className="flex flex-col sm:flex-row gap-4">
//                 <button className="group bg-white text-gray-900 px-8 py-4 rounded-lg font-bold hover:bg-gray-100 transition-all duration-300 shadow-xl hover:shadow-2xl transform hover:-translate-y-1 flex items-center justify-center space-x-2">
//                   <Download className="w-5 h-5" />
//                   <span>Download Brochure</span>
//                 </button>
//                 <a 
//                   href="tel:+918885852266"
//                   className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg font-bold hover:bg-white hover:text-gray-900 transition-all duration-300 flex items-center justify-center space-x-2"
//                 >
//                   <Phone className="w-5 h-5" />
//                   <span>Schedule Site Visit</span>
//                 </a>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Scroll Indicator */}
//         <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20 animate-bounce">
//           <ChevronDown className="w-8 h-8 text-white/60" />
//         </div>
//       </section>

//       {/* Quick Highlights Bar */}
//       <section className="bg-white py-8 shadow-lg relative z-30 -mt-20">
//         <div className="max-w-7xl mx-auto px-6">
//           <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
//             {highlights.map((item, index) => (
//               <div key={index} className="flex items-center space-x-4 p-4 bg-[#f5f3f0] rounded-lg hover:shadow-md transition-shadow duration-300">
//                 <div className="flex-shrink-0 w-12 h-12 bg-[#2C5F2D] text-white rounded-lg flex items-center justify-center">
//                   {item.icon}
//                 </div>
//                 <div>
//                   <p className="font-bold text-gray-900">{item.title}</p>
//                   <p className="text-sm text-gray-600">{item.subtitle}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* About Section */}
//       <section className="py-20 px-6 bg-[#f5f3f0]">
//         <div className="max-w-7xl mx-auto">
//           <div className="text-center mb-16">
//             <span className="text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-6 block">
//               [WELCOME TO]
//             </span>
//             <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
//               Your Dream Villa Awaits
//             </h2>
//             <p className="text-gray-600 text-lg leading-relaxed max-w-4xl mx-auto">
//               Welcome to MAA GARUDADRI, a prestigious villa plot project by Vedamsa, a trusted name in Hyderabad's real estate market with over 30 years of expertise. Strategically located in Dandupally, along the thriving Nagpur Highway, MAA GARUDADRI offers the perfect opportunity for those looking to invest in premium real estate within the Northern Growth Corridor of Hyderabad.
//             </p>
//           </div>

//           {/* Image Gallery Grid */}
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//             <div className="md:col-span-2 relative overflow-hidden rounded-2xl shadow-2xl group h-[500px]">
//               <img 
//                 src="https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=1200"
//                 alt="Premium Villa"
//                 className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
//               />
//               <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
//               <div className="absolute bottom-6 left-6 text-white">
//                 <p className="text-2xl font-bold">Premium Villa Plots</p>
//                 <p className="text-white/80">Build Your Dream Home</p>
//               </div>
//             </div>

//             <div className="space-y-6">
//               <div className="relative overflow-hidden rounded-2xl shadow-xl group h-[237px]">
//                 <img 
//                   src="https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=600"
//                   alt="Gated Community"
//                   className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
//                 />
//                 <div className="absolute inset-0 bg-black/30"></div>
//                 <div className="absolute bottom-4 left-4 text-white">
//                   <p className="text-lg font-bold">Gated Community</p>
//                 </div>
//               </div>
//               <div className="relative overflow-hidden rounded-2xl shadow-xl group h-[237px]">
//                 <img 
//                   src="https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=600"
//                   alt="Green Spaces"
//                   className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
//                 />
//                 <div className="absolute inset-0 bg-black/30"></div>
//                 <div className="absolute bottom-4 left-4 text-white">
//                   <p className="text-lg font-bold">Green Spaces</p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Auto-Scrolling Gallery */}
//       <section className="py-20 px-6 bg-white overflow-hidden">
//         <div className="max-w-7xl mx-auto mb-12">
//           <div className="text-center">
//             <span className="text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-6 block">
//               [GALLERY]
//             </span>
//             <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
//               Explore MAA Garudadri
//             </h2>
//             <p className="text-gray-600 text-lg leading-relaxed max-w-3xl mx-auto">
//               Discover the beauty and potential of premium villa plots in Dandupally's fastest-growing community
//             </p>
//           </div>
//         </div>

//         {/* Auto-scrolling container */}
//         <div 
//           ref={scrollContainerRef}
//           className="flex space-x-6 overflow-x-hidden"
//           style={{ scrollBehavior: 'smooth' }}
//         >
//           {[...galleryImages, ...galleryImages].map((image, index) => (
//             <div 
//               key={index}
//               className="flex-shrink-0 w-[400px] h-[500px] relative overflow-hidden rounded-2xl shadow-xl group"
//             >
//               <img 
//                 src={image}
//                 alt={`Gallery ${index + 1}`}
//                 className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
//               />
//               <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* Features Section */}
//       <section className="py-20 px-6 bg-[#f5f3f0]">
//         <div className="max-w-7xl mx-auto">
//           <div className="text-center mb-16">
//             <span className="text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-6 block">
//               [PREMIUM FEATURES]
//             </span>
//             <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
//               Infinite Possibilities Await
//             </h2>
//             <p className="text-gray-600 text-lg leading-relaxed max-w-3xl mx-auto">
//               MAA GARUDADRI offers meticulously planned villa plots that are perfect for building your dream home or making a secure investment
//             </p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
//             {features.map((feature, index) => (
//               <div 
//                 key={index}
//                 className="bg-white p-6 rounded-xl hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2"
//               >
//                 <div className="w-16 h-16 bg-[#2C5F2D]/10 text-[#2C5F2D] rounded-xl flex items-center justify-center mb-4">
//                   {feature.icon}
//                 </div>
//                 <h3 className="text-xl font-bold text-gray-900 mb-2">{feature.title}</h3>
//                 <p className="text-gray-600 text-sm">{feature.desc}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Connectivity Section */}
//       <section className="py-20 px-6 bg-white">
//         <div className="max-w-7xl mx-auto">
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
//             {/* Left - Image */}
//             <div className="relative overflow-hidden rounded-2xl shadow-2xl group h-[600px]">
//               <img 
//                 src="https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=800"
//                 alt="Connectivity"
//                 className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
//               />
//               <div className="absolute inset-0 bg-gradient-to-t from-[#2C5F2D]/70 via-transparent to-transparent"></div>
//               <div className="absolute bottom-8 left-8 text-white">
//                 <MapPin className="w-8 h-8 mb-2" />
//                 <p className="text-2xl font-bold">Excellent Connectivity</p>
//                 <p className="text-white/80">Northern Growth Corridor</p>
//               </div>
//             </div>

//             {/* Right - Content */}
//             <div>
//               <span className="text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-6 block">
//                 [PRIME LOCATION]
//               </span>
//               <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
//                 Dandupally, Nagpur Highway
//               </h2>
//               <p className="text-gray-600 text-lg leading-relaxed mb-8">
//                 MAA GARUDADRI is nestled in Dandupally, a rapidly developing region along the Nagpur Highway (NH-44). This area is part of Hyderabad's Northern Growth Corridor, which has become a real estate hotspot due to its excellent connectivity and infrastructure development.
//               </p>

//               <div className="grid grid-cols-1 gap-4">
//                 {connectivity.map((item, index) => (
//                   <div 
//                     key={index}
//                     className="flex items-start space-x-3 p-4 bg-[#f5f3f0] rounded-lg hover:shadow-md transition-all duration-300"
//                   >
//                     <CheckCircle className="w-5 h-5 text-[#2C5F2D] flex-shrink-0 mt-0.5" />
//                     <p className="text-gray-700 font-medium">{item}</p>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Investment Advantages */}
//       <section className="py-20 px-6 bg-[#f5f3f0]">
//         <div className="max-w-7xl mx-auto">
//           <div className="text-center mb-16">
//             <span className="text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-6 block">
//               [WHY INVEST]
//             </span>
//             <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
//               Why Invest in Villa Plots<br />on Nagpur Highway?
//             </h2>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//             {advantages.map((advantage, index) => (
//               <div 
//                 key={index}
//                 className="bg-white p-8 rounded-2xl hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2"
//               >
//                 <div className="w-20 h-20 bg-[#2C5F2D]/10 text-[#2C5F2D] rounded-xl flex items-center justify-center mb-6 shadow-md">
//                   {advantage.icon}
//                 </div>
//                 <h3 className="text-2xl font-bold text-gray-900 mb-4">{advantage.title}</h3>
//                 <p className="text-gray-600 leading-relaxed">{advantage.desc}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Vedamsa Legacy */}
//       <section className="py-20 px-6 bg-gray-900 text-white">
//         <div className="max-w-6xl mx-auto text-center">
//           <span className="text-sm uppercase tracking-[0.3em] text-gray-400 font-medium mb-6 block">
//             [TRUSTED DEVELOPER]
//           </span>
//           <h2 className="text-4xl md:text-5xl font-bold mb-8">
//             Vedamsa's Trusted Legacy
//           </h2>
//           <p className="text-gray-300 text-lg leading-relaxed max-w-4xl mx-auto mb-12">
//             With more than three decades of experience in delivering quality projects, Vedamsa has earned the trust of over 3000 happy customers. When you invest in MAA GARUDADRI, you're choosing a developer known for uncompromising quality, transparent processes, timely deliveries, and a customer-centric approach.
//           </p>

//           <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
//             {whyVedamsa.map((item, index) => (
//               <div 
//                 key={index}
//                 className="bg-white/5 backdrop-blur-sm border border-white/10 p-8 rounded-xl hover:bg-white/10 transition-all duration-300"
//               >
//                 <p className="text-5xl font-bold mb-2 text-[#4A7C59]">{item.number}</p>
//                 <p className="text-gray-400">{item.text}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Location Map */}
//       <section className="py-20 px-6 bg-white">
//         <div className="max-w-7xl mx-auto">
//           <div className="text-center mb-12">
//             <span className="text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-6 block">
//               [LOCATION]
//             </span>
//             <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
//               Find Us Here
//             </h2>
//           </div>

//           {/* Map */}
//           <div className="relative overflow-hidden rounded-2xl shadow-2xl h-[500px] group">
//             <iframe
//               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3804.7441616893837!2d78.19588450000001!3d17.5527712!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcbf12a5f2662cf%3A0xc385d29a5612e332!2sVedamsa%20Infrastructure%20pvt%20ltd!5e0!3m2!1sen!2sus!4v1234567890123!5m2!1sen!2sus"
//               width="100%"
//               height="100%"
//               style={{ border: 0 }}
//               allowFullScreen=""
//               loading="lazy"
//               referrerPolicy="no-referrer-when-downgrade"
//               className="w-full h-full"
//             ></iframe>
            
//             <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent pointer-events-none"></div>
//             <div className="absolute bottom-8 left-8 right-8 pointer-events-auto">
//               <div className="bg-white/95 backdrop-blur-sm rounded-xl p-6 shadow-2xl">
//                 <div className="flex items-start justify-between">
//                   <div className="flex-1">
//                     <MapPin className="w-8 h-8 text-[#2C5F2D] mb-2" />
//                     <p className="text-2xl font-bold text-gray-900 mb-2">MAA Garudadri, Dandupally</p>
//                     <p className="text-gray-600 mb-4">Nagpur Highway (NH-44), Hyderabad</p>
//                   </div>
//                 </div>
//                 <a 
//                   href="https://www.google.com/maps/place/Vedamsa+Infrastructure+pvt+ltd/@17.552771,78.195885,10z/data=!4m6!3m5!1s0x3bcbf12a5f2662cf:0xc385d29a5612e332!8m2!3d17.5527712!4d78.1958845!16s%2Fg%2F11vyt53tgr?hl=en-US&entry=ttu&g_ep=EgoyMDI1MTIwOS4wIKXMDSoASAFQAw%3D%3D"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="inline-flex items-center space-x-2 bg-[#2C5F2D] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#234a26] transition-all duration-300 shadow-lg hover:shadow-xl"
//                 >
//                   <span>Get Directions</span>
//                   <ExternalLink className="w-5 h-5" />
//                 </a>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Final CTA */}
//       <section className="relative h-screen overflow-hidden">
//         <div 
//           className="absolute inset-0 bg-cover bg-center"
//           style={{
//             backgroundImage: `url('https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1920')`,
//           }}
//         ></div>

//         <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

//         <div className="relative z-10 h-full flex items-center justify-center px-6">
//           <div className="max-w-4xl mx-auto text-center text-white">
//             <h2 className="text-5xl md:text-7xl font-bold mb-6 drop-shadow-2xl">
//               Build Your Future
//             </h2>
//             <p className="text-2xl md:text-3xl text-white mb-4 font-light drop-shadow-lg">
//               Premium Villa Plots in Dandupally
//             </p>
//             <p className="text-xl text-white/90 mb-12 drop-shadow-lg">
//               Nagpur Highway - Northern Growth Corridor, Hyderabad
//             </p>

//             <div className="flex flex-col sm:flex-row gap-6 justify-center">
//               <button className="bg-white text-gray-900 px-10 py-5 rounded-lg font-bold hover:bg-gray-100 transition-all duration-300 shadow-2xl hover:shadow-3xl transform hover:-translate-y-1 text-lg flex items-center justify-center space-x-2">
//                 <Download className="w-6 h-6" />
//                 <span>Download Brochure</span>
//               </button>
//               <a 
//                 href="tel:+918885852266"
//                 className="bg-[#2C5F2D] border-2 border-[#2C5F2D] text-white px-10 py-5 rounded-lg font-bold hover:bg-[#234a26] hover:border-[#234a26] transition-all duration-300 shadow-2xl text-lg flex items-center justify-center space-x-2"
//               >
//                 <Phone className="w-6 h-6" />
//                 <span>Call: +91 8885852266</span>
//               </a>
//             </div>

//             <div className="mt-12 pt-12 border-t border-white/30">
//               <p className="text-white/90 mb-4 drop-shadow-lg">Contact Vedamsa Infrastructure</p>
//               <div className="flex flex-col sm:flex-row gap-6 justify-center text-white">
//                 <a href="tel:+918885852266" className="flex items-center justify-center space-x-2 hover:text-white/80 transition-colors drop-shadow-lg">
//                   <Phone className="w-5 h-5" />
//                   <span>+91 8885852266</span>
//                 </a>
//                 <a href="mailto:Vedamsa@gmail.com" className="flex items-center justify-center space-x-2 hover:text-white/80 transition-colors drop-shadow-lg">
//                   <Mail className="w-5 h-5" />
//                   <span>Vedamsa@gmail.com</span>
//                 </a>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Footer */}
//       <footer className="bg-[#1a1a1a] text-white py-12 px-6">
//         <div className="max-w-7xl mx-auto">
//           <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
//             <div className="md:col-span-2">
//               <div className="flex items-center space-x-3 mb-4">
//                 <div className="bg-white text-gray-900 p-2 rounded">
//                   <Building2 className="w-6 h-6" />
//                 </div>
//                 <span className="text-2xl font-bold">Vedamsa</span>
//               </div>
//               <p className="text-gray-400 mb-4">Building Dreams, Creating Futures</p>
//               <p className="text-gray-500 text-sm">MAA Garudadri - Premium Villa Plots in Dandupally, Nagpur Highway</p>
//             </div>

//             <div>
//               <h4 className="font-bold mb-4">Quick Links</h4>
//               <div className="space-y-2 text-gray-400">
//                 <Link to="/" className="block hover:text-white transition-colors">Home</Link>
//                 <Link to="/about" className="block hover:text-white transition-colors">About Vedamsa</Link>
//                 <Link to="/contact" className="block hover:text-white transition-colors">Contact Us</Link>
//               </div>
//             </div>

//             <div>
//               <h4 className="font-bold mb-4">Contact</h4>
//               <div className="space-y-2 text-gray-400">
//                 <p>Dandupally, Hyderabad</p>
//                 <p>+91 8885852266</p>
//                 <p>Vedamsa@gmail.com</p>
//               </div>
//             </div>
//           </div>

//           <div className="border-t border-gray-700 pt-8 text-center">
//             <p className="text-gray-500 text-sm">© 2025 Vedamsa Infrastructure. All rights reserved. | MAA Garudadri</p>
//           </div>
//         </div>
//       </footer>
//     </div>
//   );
// };

// export default MaaGarudadriPage;


// import React, { useState, useEffect, useRef } from 'react';
// import { Link } from 'react-router-dom';
// import { 
//   Building2, 
//   MapPin, 
//   Download, 
//   CheckCircle, 
//   Home,
//   TreePine,
//   Shield,
//   Phone,
//   Mail,
//   ArrowRight,
//   ChevronDown,
//   Star,
//   TrendingUp,
//   Users,
//   Award,
//   ExternalLink,
//   Droplets,
//   Zap,
//   Ruler,
//   Lock,
//   ParkingCircle,
//   Activity,
//   Globe,
//   Briefcase,
//   GraduationCap,
//   Building,
//   Heart,
//   Clock,
//   Lightbulb
// } from 'lucide-react';
// import garudadri from  '../Images/garuda.png';
// import post1 from '../Images/g-post.png';
// import post2 from '../Images/g-post2.png';
// import post3 from '../Images/g-post3.png';
// import post4 from '../Images/Maa_Garudadri_page_1 (1).png';
// import road from '../Images/ES491735.jpg';

// const MaaGarudadriPage = () => {
//   const [scrolled, setScrolled] = useState(false);
//   const scrollContainerRef = useRef(null);

//   useEffect(() => {
//     const handleScroll = () => {
//       setScrolled(window.scrollY > 50);
//     };
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   // Auto-scroll gallery
//   useEffect(() => {
//     const container = scrollContainerRef.current;
//     if (!container) return;

//     let scrollAmount = 0;
//     const scrollStep = 1;
//     const scrollInterval = 30;

//     const autoScroll = setInterval(() => {
//       if (container.scrollLeft >= container.scrollWidth - container.clientWidth) {
//         container.scrollLeft = 0;
//         scrollAmount = 0;
//       } else {
//         container.scrollLeft += scrollStep;
//         scrollAmount += scrollStep;
//       }
//     }, scrollInterval);

//     return () => clearInterval(autoScroll);
//   }, []);

//   const highlights = [
//     { icon: <Home className="w-6 h-6" />, title: 'Villa Plots', subtitle: 'Premium Layouts' },
//     { icon: <MapPin className="w-6 h-6" />, title: 'Dandupally', subtitle: 'Nagpur Highway' },
//     { icon: <Building2 className="w-6 h-6" />, title: 'Vastu Compliant', subtitle: 'Perfect Design' },
//     { icon: <Star className="w-6 h-6" />, title: 'Value-Driven', subtitle: 'Competitive Price' }
//   ];

//   const galleryImages = [
//     'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=800',
//     'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800',
//     'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800',
//     'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=800',
//     'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800',
//     'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=800',
//     'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800',
//     'https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=800'
//   ];

//   const features = [
//     {
//       icon: <Ruler className="w-8 h-8" />,
//       title: 'Vastu-Compliant Layouts',
//       desc: 'Ensuring harmony and prosperity in every plot'
//     },
//     {
//       icon: <ParkingCircle className="w-8 h-8" />,
//       title: 'Wide Roads',
//       desc: 'Modern infrastructure with 40-60 feet roads'
//     },
//     {
//       icon: <Zap className="w-8 h-8" />,
//       title: 'Underground Utilities',
//       desc: 'Power supply and drainage systems'
//     },
//     {
//       icon: <TreePine className="w-8 h-8" />,
//       title: 'Ample Green Spaces',
//       desc: 'Landscaped parks and gardens'
//     },
//     {
//       icon: <Shield className="w-8 h-8" />,
//       title: '24/7 Security',
//       desc: 'Secure gated community with CCTV'
//     },
//     {
//       icon: <Droplets className="w-8 h-8" />,
//       title: 'Rainwater Harvesting',
//       desc: 'Environmentally conscious development'
//     },
//     {
//       icon: <Activity className="w-8 h-8" />,
//       title: 'Fitness Zones',
//       desc: 'Jogging tracks and outdoor gym'
//     },
//     {
//       icon: <Lock className="w-8 h-8" />,
//       title: 'Gated Community',
//       desc: 'Complete peace of mind for residents'
//     }
//   ];

//   const connectivity = [
//     'Close proximity to Outer Ring Road (ORR)',
//     'Easy commute to IT hubs like Gachibowli & HITEC City',
//     'Well-connected to Rajiv Gandhi International Airport',
//     'Near Pharma City & Aerospace SEZ',
//     'Educational institutions within reach',
//     'Hospitals and healthcare facilities nearby',
//     'Shopping centers and malls accessible',
//     'Excellent public transport connectivity'
//   ];

//   const advantages = [
//     {
//       icon: <TrendingUp className="w-10 h-10" />,
//       title: 'Strategic Growth Corridor',
//       desc: 'Connects Hyderabad to major cities, making it ideal for residential and commercial developments'
//     },
//     {
//       icon: <Building2 className="w-10 h-10" />,
//       title: 'Infrastructure Boom',
//       desc: 'Government focus on industrial corridors, logistics hubs, and upgraded roads'
//     },
//     {
//       icon: <Award className="w-10 h-10" />,
//       title: 'Future-Ready Location',
//       desc: "Dandupally's strategic location ensures high returns on investment"
//     },
//     {
//       icon: <Users className="w-10 h-10" />,
//       title: 'Planned Community Living',
//       desc: 'Landscaped parks, fitness zones, and modern amenities for comfortable living'
//     }
//   ];

//   const whyVedamsa = [
//     { number: '30+', text: 'Years of Experience' },
//     { number: '3000+', text: 'Satisfied Customers' },
//     { number: '100%', text: 'Quality Commitment' },
//     { number: '100%', text: 'Transparent Practices' }
//   ];

//   return (
//     <div className="min-h-screen bg-[#f5f3f0]">
//       {/* Hero Section */}
//       <section className="relative h-screen w-full overflow-hidden">
//         <div 
//           className="absolute inset-0 bg-cover bg-center"
//           style={{
//             backgroundImage: `url(${garudadri})`,
//           }}
//         ></div>
        
//         {/* <div className="absolute inset-0 bg-gradient-to-br from-[#2C5F2D]/90 via-[#4A7C59]/70 to-transparent"></div> */}

//         <div className="relative z-20 h-full flex items-center">
//           <div className="max-w-7xl mx-auto px-6 w-full">
//             <div className="max-w-3xl">
//               <div className="inline-block mb-6 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-6 py-2">
//                 <span className="text-white text-sm font-medium">By Vedamsa - 30 Years of Excellence</span>
//               </div>

//               <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
//                 MAA Garudadri
//               </h1>
              
//               <p className="text-2xl md:text-3xl text-white/90 mb-4 font-light">
//                 Premium Villa Plots
//               </p>
              
//               <p className="text-xl text-white/80 mb-8">
//                 Dandupally, Nagpur Highway (NH-44)
//               </p>

//               <div className="inline-block bg-white rounded-2xl px-8 py-4 mb-10 shadow-2xl">
//                 <p className="text-gray-600 text-sm mb-1">Northern Growth Corridor</p>
//                 <p className="text-2xl font-bold text-[#2C5F2D]">Hyderabad's Prime Location</p>
//               </div>

//               <div className="flex flex-col sm:flex-row gap-4">
//                 <button className="group bg-white text-gray-900 px-8 py-4 rounded-lg font-bold hover:bg-gray-100 transition-all duration-300 shadow-xl hover:shadow-2xl transform hover:-translate-y-1 flex items-center justify-center space-x-2">
//                   <Download className="w-5 h-5" />
//                   <span>Download Brochure</span>
//                 </button>
//                 <a 
//                   href="tel:+918885852266"
//                   className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg font-bold hover:bg-white hover:text-gray-900 transition-all duration-300 flex items-center justify-center space-x-2"
//                 >
//                   <Phone className="w-5 h-5" />
//                   <span>Schedule Site Visit</span>
//                 </a>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20 animate-bounce">
//           <ChevronDown className="w-8 h-8 text-white/60" />
//         </div>
//       </section>

//       {/* Quick Highlights Bar */}
//       <section className="bg-white py-8 shadow-lg relative z-30 -mt-20">
//         <div className="max-w-7xl mx-auto px-6">
//           <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
//             {highlights.map((item, index) => (
//               <div key={index} className="flex items-center space-x-4 p-4 bg-[#f5f3f0] rounded-lg hover:shadow-md transition-shadow duration-300">
//                 <div className="flex-shrink-0 w-12 h-12 bg-[#2C5F2D] text-white rounded-lg flex items-center justify-center">
//                   {item.icon}
//                 </div>
//                 <div>
//                   <p className="font-bold text-gray-900">{item.title}</p>
//                   <p className="text-sm text-gray-600">{item.subtitle}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* About Section */}
//       <section className="py-20 px-6 bg-[#f5f3f0]">
//         <div className="max-w-7xl mx-auto">
//           <div className="text-center mb-16">
//             <span className="text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-6 block">
//               [WELCOME TO]
//             </span>
//             <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
//               Your Dream Villa Awaits
//             </h2>
//             <p className="text-gray-600 text-lg leading-relaxed max-w-4xl mx-auto">
//               Welcome to MAA GARUDADRI, a prestigious villa plot project by Vedamsa, a trusted name in Hyderabad's real estate market with over 30 years of expertise. Strategically located in Dandupally, along the thriving Nagpur Highway, MAA GARUDADRI offers the perfect opportunity for those looking to invest in premium real estate within the Northern Growth Corridor of Hyderabad.
//             </p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//             <div className="md:col-span-2 relative overflow-hidden rounded-2xl shadow-2xl group h-[500px]">
//               <img 
//                 src={post3}
//                 alt="Premium Villa"
//                 className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
//               />
//               <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
//               <div className="absolute bottom-6 left-6 text-white">
//                 <p className="text-2xl font-bold">Premium Villa Plots</p>
//                 <p className="text-white/80">Build Your Dream Home</p>
//               </div>
//             </div>

//             <div className="space-y-6">
//               <div className="relative overflow-hidden rounded-2xl shadow-xl group h-[237px]">
//                 <img 
//                   src={post2}
//                   alt="Gated Community"
//                   className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
//                 />
//                 <div className="absolute inset-0 bg-black/30"></div>
//                 <div className="absolute bottom-4 left-4 text-white">
//                   <p className="text-lg font-bold">Gated Community</p>
//                 </div>
//               </div>
//               <div className="relative overflow-hidden rounded-2xl shadow-xl group h-[237px]">
//                 <img 
//                   src="https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=600"
//                   alt="Green Spaces"
//                   className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
//                 />
//                 <div className="absolute inset-0 bg-black/30"></div>
//                 <div className="absolute bottom-4 left-4 text-white">
//                   <p className="text-lg font-bold">Green Spaces</p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* NEW: Why Choose MAA GARUDADRI Section with 3 Images */}
//       <section className="py-20 px-6 bg-white">
//         <div className="max-w-7xl mx-auto">
//           <div className="text-center mb-16">
//             <span className="text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-6 block">
//               [WHY CHOOSE US]
//             </span>
//             <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
//               Why Choose MAA GARUDADRI?
//             </h2>
//             <h3 className="text-2xl font-semibold text-[#2C5F2D] mb-8">
//               Prime Location: Dandupally, Nagpur Highway
//             </h3>
//             <p className="text-gray-600 text-lg leading-relaxed max-w-4xl mx-auto">
//               MAA GARUDADRI is nestled in Dandupally, a rapidly developing region along the Nagpur Highway (NH-44). This area is part of Hyderabad's Northern Growth Corridor, which has become a real estate hotspot due to its excellent connectivity and infrastructure development.
//             </p>
//           </div>

//           {/* Three Feature Cards with Images */}
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
//             {/* Seamless Connectivity */}
//             <div className="bg-[#f5f3f0] rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
//               <div className="relative h-64 overflow-hidden">
//                 <img 
//                   src={road}
//                   alt="Seamless Connectivity"
//                   className="w-full h-full object-cover transform hover:scale-110 transition-transform duration-700"
//                 />
//                 <div className="absolute inset-0 bg-gradient-to-t from-[#2C5F2D]/80 via-transparent to-transparent"></div>
//                 <div className="absolute bottom-4 left-4">
//                   <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center mb-2">
//                     <Globe className="w-6 h-6 text-[#2C5F2D]" />
//                   </div>
//                 </div>
//               </div>
//               <div className="p-6">
//                 <h4 className="text-xl font-bold text-gray-900 mb-3">Seamless Connectivity</h4>
//                 <p className="text-gray-600 leading-relaxed">
//                   Close proximity to ORR, IT hubs, and industrial zones ensuring easy commute and excellent accessibility
//                 </p>
//               </div>
//             </div>

//             {/* Urban Amenities */}
//             <div className="bg-[#f5f3f0] rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
//               <div className="relative h-64 overflow-hidden">
//                 <img 
//                   src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=600"
//                   alt="Urban Amenities"
//                   className="w-full h-full object-cover transform hover:scale-110 transition-transform duration-700"
//                 />
//                 <div className="absolute inset-0 bg-gradient-to-t from-[#2C5F2D]/80 via-transparent to-transparent"></div>
//                 <div className="absolute bottom-4 left-4">
//                   <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center mb-2">
//                     <Building className="w-6 h-6 text-[#2C5F2D]" />
//                   </div>
//                 </div>
//               </div>
//               <div className="p-6">
//                 <h4 className="text-xl font-bold text-gray-900 mb-3">Access to Urban Amenities</h4>
//                 <p className="text-gray-600 leading-relaxed">
//                   Educational institutions, hospitals, and shopping centers within easy reach for your convenience
//                 </p>
//               </div>
//             </div>

//             {/* Future Growth */}
//             <div className="bg-[#f5f3f0] rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
//               <div className="relative h-64 overflow-hidden">
//                 <img 
//                   src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600"
//                   alt="Future Growth"
//                   className="w-full h-full object-cover transform hover:scale-110 transition-transform duration-700"
//                 />
//                 <div className="absolute inset-0 bg-gradient-to-t from-[#2C5F2D]/80 via-transparent to-transparent"></div>
//                 <div className="absolute bottom-4 left-4">
//                   <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center mb-2">
//                     <TrendingUp className="w-6 h-6 text-[#2C5F2D]" />
//                   </div>
//                 </div>
//               </div>
//               <div className="p-6">
//                 <h4 className="text-xl font-bold text-gray-900 mb-3">Future Growth Potential</h4>
//                 <p className="text-gray-600 leading-relaxed">
//                   Proximity to key projects like Pharma City and Aerospace SEZ enhances the value of the region
//                 </p>
//               </div>
//             </div>
//           </div>

//           <div className="text-center">
//             <p className="text-gray-700 text-lg font-medium max-w-3xl mx-auto">
//               For those looking for villa plots for sale in Nagpur Highway, this location combines urban convenience with serene living.
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* NEW: Vedamsa's Trusted Legacy Section with Image */}
//       <section className="py-20 px-6 bg-[#f5f3f0]">
//         <div className="max-w-7xl mx-auto">
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
//             {/* Left - Image */}
//             <div className="relative overflow-hidden rounded-2xl shadow-2xl group h-[600px] order-2 lg:order-1">
//               <img 
//                 src={post1}
//                 alt="Vedamsa Legacy"
//                 className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
//               />
//               <div className="absolute inset-0 bg-gradient-to-t from-[#2C5F2D]/70 via-transparent to-transparent"></div>
//               <div className="absolute bottom-8 left-8 text-white">
//                 <Award className="w-10 h-10 mb-2" />
//                 <p className="text-3xl font-bold">30+ Years</p>
//                 <p className="text-white/80">of Excellence & Trust</p>
//               </div>
//             </div>

//             {/* Right - Content */}
//             <div className="order-1 lg:order-2">
//               <span className="text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-6 block">
//                 [TRUSTED DEVELOPER]
//               </span>
//               <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
//                 Vedamsa's Trusted Legacy
//               </h2>
//               <p className="text-gray-600 text-lg leading-relaxed mb-8">
//                 With more than three decades of experience in delivering quality projects, Vedamsa has earned the trust of over 3000 happy customers. When you invest in MAA GARUDADRI, you're choosing a developer known for:
//               </p>

//               <div className="space-y-4">
//                 <div className="flex items-start space-x-4 p-4 bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300">
//                   <div className="flex-shrink-0 w-12 h-12 bg-[#2C5F2D]/10 rounded-lg flex items-center justify-center">
//                     <Award className="w-6 h-6 text-[#2C5F2D]" />
//                   </div>
//                   <div>
//                     <h4 className="font-bold text-gray-900 mb-1">Uncompromising Quality</h4>
//                     <p className="text-gray-600 text-sm">Every project built to the highest standards</p>
//                   </div>
//                 </div>

//                 <div className="flex items-start space-x-4 p-4 bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300">
//                   <div className="flex-shrink-0 w-12 h-12 bg-[#2C5F2D]/10 rounded-lg flex items-center justify-center">
//                     <CheckCircle className="w-6 h-6 text-[#2C5F2D]" />
//                   </div>
//                   <div>
//                     <h4 className="font-bold text-gray-900 mb-1">Transparent Processes</h4>
//                     <p className="text-gray-600 text-sm">Complete clarity in every transaction</p>
//                   </div>
//                 </div>

//                 <div className="flex items-start space-x-4 p-4 bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300">
//                   <div className="flex-shrink-0 w-12 h-12 bg-[#2C5F2D]/10 rounded-lg flex items-center justify-center">
//                     <Clock className="w-6 h-6 text-[#2C5F2D]" />
//                   </div>
//                   <div>
//                     <h4 className="font-bold text-gray-900 mb-1">Timely Deliveries</h4>
//                     <p className="text-gray-600 text-sm">Committed to meeting deadlines</p>
//                   </div>
//                 </div>

//                 <div className="flex items-start space-x-4 p-4 bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300">
//                   <div className="flex-shrink-0 w-12 h-12 bg-[#2C5F2D]/10 rounded-lg flex items-center justify-center">
//                     <Heart className="w-6 h-6 text-[#2C5F2D]" />
//                   </div>
//                   <div>
//                     <h4 className="font-bold text-gray-900 mb-1">Customer-Centric Approach</h4>
//                     <p className="text-gray-600 text-sm">Your satisfaction is our priority</p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* NEW: Premium Villa Plots Section with Image */}
//       <section className="py-20 px-6 bg-white">
//         <div className="max-w-7xl mx-auto">
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
//             {/* Left - Content */}
//             <div>
//               <span className="text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-6 block">
//                 [PREMIUM PLOTS]
//               </span>
//               <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
//                 Premium Villa Plots with Infinite Possibilities
//               </h2>
//               <p className="text-gray-600 text-lg leading-relaxed mb-8">
//                 MAA GARUDADRI offers meticulously planned villa plots that are perfect for building your dream home or making a secure investment. Key features include:
//               </p>

//               <div className="space-y-6">
//                 <div className="flex items-start space-x-4">
//                   <div className="flex-shrink-0 w-12 h-12 bg-[#2C5F2D] text-white rounded-lg flex items-center justify-center">
//                     <Ruler className="w-6 h-6" />
//                   </div>
//                   <div>
//                     <h4 className="font-bold text-gray-900 mb-2">Vastu-Compliant Layouts</h4>
//                     <p className="text-gray-600">Ensuring harmony and prosperity in every aspect of your home</p>
//                   </div>
//                 </div>

//                 <div className="flex items-start space-x-4">
//                   <div className="flex-shrink-0 w-12 h-12 bg-[#2C5F2D] text-white rounded-lg flex items-center justify-center">
//                     <Building2 className="w-6 h-6" />
//                   </div>
//                   <div>
//                     <h4 className="font-bold text-gray-900 mb-2">Modern Infrastructure</h4>
//                     <p className="text-gray-600">Wide roads, underground utilities, and ample green spaces</p>
//                   </div>
//                 </div>

//                 <div className="flex items-start space-x-4">
//                   <div className="flex-shrink-0 w-12 h-12 bg-[#2C5F2D] text-white rounded-lg flex items-center justify-center">
//                     <Shield className="w-6 h-6" />
//                   </div>
//                   <div>
//                     <h4 className="font-bold text-gray-900 mb-2">Secure Gated Community</h4>
//                     <p className="text-gray-600">24/7 security for complete peace of mind</p>
//                   </div>
//                 </div>
//               </div>

//               <div className="mt-8 p-6 bg-[#f5f3f0] rounded-xl border-l-4 border-[#2C5F2D]">
//                 <p className="text-gray-700 font-medium">
//                   Whether you're seeking to buy villa plots in Nagpur Highway for residential or investment purposes, MAA GARUDADRI offers a future-ready solution.
//                 </p>
//               </div>
//             </div>

//             {/* Right - Image */}
//             <div className="relative overflow-hidden rounded-2xl shadow-2xl group h-[600px]">
//               <img 
//                 src={post4}
//                 alt="Villa Plot Layout"
//                 className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
//               />
//               <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
//               <div className="absolute bottom-8 left-8 right-8">
//                 <div className="bg-white/95 backdrop-blur-sm rounded-xl p-6">
//                   <h3 className="text-2xl font-bold text-gray-900 mb-2">Build Your Dream</h3>
//                   <p className="text-gray-600">Flexible plots for custom villa designs</p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* NEW: What Sets MAA GARUDADRI Apart Section */}
//       <section className="py-20 px-6 bg-gray-900 text-white">
//         <div className="max-w-7xl mx-auto">
//           <div className="text-center mb-16">
//             <span className="text-sm uppercase tracking-[0.3em] text-gray-400 font-medium mb-6 block">
//               [WHAT SETS US APART]
//             </span>
//             <h2 className="text-4xl md:text-5xl font-bold mb-6">
//               What Sets MAA GARUDADRI Apart?
//             </h2>
//             <p className="text-gray-300 text-lg max-w-3xl mx-auto">
//               Experience the difference with our comprehensive community features and environmentally conscious development
//             </p>
//           </div>

//           <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
//             {/* Planned Community Living */}
//             <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl overflow-hidden hover:bg-white/10 transition-all duration-300">
//               <div className="relative h-64 overflow-hidden">
//                 <img 
//                   src="https://images.unsplash.com/photo-1587582423116-ec07293f0395?w=600"
//                   alt="Community Living"
//                   className="w-full h-full object-cover transform hover:scale-110 transition-transform duration-700"
//                 />
//                 <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent"></div>
//                 <div className="absolute bottom-4 left-4">
//                   <div className="w-12 h-12 bg-[#2C5F2D] rounded-lg flex items-center justify-center">
//                     <Users className="w-6 h-6 text-white" />
//                   </div>
//                 </div>
//               </div>
//               <div className="p-6">
//                 <h3 className="text-2xl font-bold mb-4">1. Planned Community Living</h3>
//                 <ul className="space-y-3 text-gray-300">
//                   <li className="flex items-start space-x-2">
//                     <CheckCircle className="w-5 h-5 text-[#4A7C59] flex-shrink-0 mt-0.5" />
//                     <span>Landscaped parks, jogging tracks, fitness zones</span>
//                   </li>
//                   <li className="flex items-start space-x-2">
//                     <CheckCircle className="w-5 h-5 text-[#4A7C59] flex-shrink-0 mt-0.5" />
//                     <span>Underground drainage & power supply</span>
//                   </li>
//                   <li className="flex items-start space-x-2">
//                     <CheckCircle className="w-5 h-5 text-[#4A7C59] flex-shrink-0 mt-0.5" />
//                     <span>24/7 security services</span>
//                   </li>
//                 </ul>
//               </div>
//             </div>

//             {/* Flexibility in Design */}
//             <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl overflow-hidden hover:bg-white/10 transition-all duration-300">
//               <div className="relative h-64 overflow-hidden">
//                 <img 
//                   src="https://images.unsplash.com/photo-1503174971373-b1f69850bded?w=600"
//                   alt="Design Flexibility"
//                   className="w-full h-full object-cover transform hover:scale-110 transition-transform duration-700"
//                 />
//                 <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent"></div>
//                 <div className="absolute bottom-4 left-4">
//                   <div className="w-12 h-12 bg-[#2C5F2D] rounded-lg flex items-center justify-center">
//                     <Lightbulb className="w-6 h-6 text-white" />
//                   </div>
//                 </div>
//               </div>
//               <div className="p-6">
//                 <h3 className="text-2xl font-bold mb-4">2. Flexibility in Design</h3>
//                 <ul className="space-y-3 text-gray-300">
//                   <li className="flex items-start space-x-2">
//                     <CheckCircle className="w-5 h-5 text-[#4A7C59] flex-shrink-0 mt-0.5" />
//                     <span>Villa plots allowing you to build your dream home</span>
//                   </li>
//                   <li className="flex items-start space-x-2">
//                     <CheckCircle className="w-5 h-5 text-[#4A7C59] flex-shrink-0 mt-0.5" />
//                     <span>Customizable layouts to suit your needs</span>
//                   </li>
//                   <li className="flex items-start space-x-2">
//                     <CheckCircle className="w-5 h-5 text-[#4A7C59] flex-shrink-0 mt-0.5" />
//                     <span>Freedom to create your perfect living space</span>
//                   </li>
//                 </ul>
//               </div>
//             </div>

//             {/* Environmentally Conscious */}
//             <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl overflow-hidden hover:bg-white/10 transition-all duration-300">
//               <div className="relative h-64 overflow-hidden">
//                 <img 
//                   src="https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?w=600"
//                   alt="Environmental"
//                   className="w-full h-full object-cover transform hover:scale-110 transition-transform duration-700"
//                 />
//                 <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent"></div>
//                 <div className="absolute bottom-4 left-4">
//                   <div className="w-12 h-12 bg-[#2C5F2D] rounded-lg flex items-center justify-center">
//                     <TreePine className="w-6 h-6 text-white" />
//                   </div>
//                 </div>
//               </div>
//               <div className="p-6">
//                 <h3 className="text-2xl font-bold mb-4">3. Environmentally Conscious</h3>
//                 <ul className="space-y-3 text-gray-300">
//                   <li className="flex items-start space-x-2">
//                     <CheckCircle className="w-5 h-5 text-[#4A7C59] flex-shrink-0 mt-0.5" />
//                     <span>Rainwater harvesting systems</span>
//                   </li>
//                   <li className="flex items-start space-x-2">
//                     <CheckCircle className="w-5 h-5 text-[#4A7C59] flex-shrink-0 mt-0.5" />
//                     <span>Energy-efficient lighting throughout</span>
//                   </li>
//                   <li className="flex items-start space-x-2">
//                     <CheckCircle className="w-5 h-5 text-[#4A7C59] flex-shrink-0 mt-0.5" />
//                     <span>Extensive plantation and green cover</span>
//                   </li>
//                 </ul>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Auto-Scrolling Gallery */}
//       {/* <section className="py-20 px-6 bg-white overflow-hidden">
//         <div className="max-w-7xl mx-auto mb-12">
//           <div className="text-center">
//             <span className="text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-6 block">
//               [GALLERY]
//             </span>
//             <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
//               Explore MAA Garudadri
//             </h2>
//             <p className="text-gray-600 text-lg leading-relaxed max-w-3xl mx-auto">
//               Discover the beauty and potential of premium villa plots in Dandupally's fastest-growing community
//             </p>
//           </div>
//         </div>

//         <div 
//           ref={scrollContainerRef}
//           className="flex space-x-6 overflow-x-hidden"
//           style={{ scrollBehavior: 'smooth' }}
//         >
//           {[...galleryImages, ...galleryImages].map((image, index) => (
//             <div 
//               key={index}
//               className="flex-shrink-0 w-[400px] h-[500px] relative overflow-hidden rounded-2xl shadow-xl group"
//             >
//               <img 
//                 src={image}
//                 alt={`Gallery ${index + 1}`}
//                 className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
//               />
//               <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
//             </div>
//           ))}
//         </div>
//       </section> */}

//       {/* Features Section */}
//       <section className="py-20 px-6 bg-[#f5f3f0]">
//         <div className="max-w-7xl mx-auto">
//           <div className="text-center mb-16">
//             <span className="text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-6 block">
//               [PREMIUM FEATURES]
//             </span>
//             <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
//               World-Class Amenities
//             </h2>
//             <p className="text-gray-600 text-lg leading-relaxed max-w-3xl mx-auto">
//               Experience modern living with comprehensive facilities designed for your comfort and convenience
//             </p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
//             {features.map((feature, index) => (
//               <div 
//                 key={index}
//                 className="bg-white p-6 rounded-xl hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2"
//               >
//                 <div className="w-16 h-16 bg-[#2C5F2D]/10 text-[#2C5F2D] rounded-xl flex items-center justify-center mb-4">
//                   {feature.icon}
//                 </div>
//                 <h3 className="text-xl font-bold text-gray-900 mb-2">{feature.title}</h3>
//                 <p className="text-gray-600 text-sm">{feature.desc}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Investment Advantages */}
//       <section className="py-20 px-6 bg-white">
//         <div className="max-w-7xl mx-auto">
//           <div className="text-center mb-16">
//             <span className="text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-6 block">
//               [WHY INVEST]
//             </span>
//             <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
//               Why Invest in Villa Plots<br />on Nagpur Highway?
//             </h2>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//             {advantages.map((advantage, index) => (
//               <div 
//                 key={index}
//                 className="bg-[#f5f3f0] p-8 rounded-2xl hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2"
//               >
//                 <div className="w-20 h-20 bg-white text-[#2C5F2D] rounded-xl flex items-center justify-center mb-6 shadow-md">
//                   {advantage.icon}
//                 </div>
//                 <h3 className="text-2xl font-bold text-gray-900 mb-4">{advantage.title}</h3>
//                 <p className="text-gray-600 leading-relaxed">{advantage.desc}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Location Map */}
//       <section className="py-20 px-6 bg-[#f5f3f0]">
//         <div className="max-w-7xl mx-auto">
//           <div className="text-center mb-12">
//             <span className="text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-6 block">
//               [LOCATION]
//             </span>
//             <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
//               Find Us Here
//             </h2>
//           </div>

//           <div className="relative overflow-hidden rounded-2xl shadow-2xl h-[500px] group">
//             <iframe
//               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3804.7441616893837!2d78.19588450000001!3d17.5527712!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcbf12a5f2662cf%3A0xc385d29a5612e332!2sVedamsa%20Infrastructure%20pvt%20ltd!5e0!3m2!1sen!2sus!4v1234567890123!5m2!1sen!2sus"
//               width="100%"
//               height="100%"
//               style={{ border: 0 }}
//               allowFullScreen=""
//               loading="lazy"
//               referrerPolicy="no-referrer-when-downgrade"
//               className="w-full h-full"
//             ></iframe>
            
//             <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent pointer-events-none"></div>
//             <div className="absolute bottom-8 left-8 right-8 pointer-events-auto">
//               <div className="bg-white/95 backdrop-blur-sm rounded-xl p-6 shadow-2xl">
//                 <div className="flex items-start justify-between">
//                   <div className="flex-1">
//                     <MapPin className="w-8 h-8 text-[#2C5F2D] mb-2" />
//                     <p className="text-2xl font-bold text-gray-900 mb-2">MAA Garudadri, Dandupally</p>
//                     <p className="text-gray-600 mb-4">Nagpur Highway (NH-44), Hyderabad</p>
//                   </div>
//                 </div>
//                 <a 
//                   href="https://www.google.com/maps/place/Vedamsa+Infrastructure+pvt+ltd/@17.552771,78.195885,10z/data=!4m6!3m5!1s0x3bcbf12a5f2662cf:0xc385d29a5612e332!8m2!3d17.5527712!4d78.1958845!16s%2Fg%2F11vyt53tgr?hl=en-US&entry=ttu&g_ep=EgoyMDI1MTIwOS4wIKXMDSoASAFQAw%3D%3D"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="inline-flex items-center space-x-2 bg-[#2C5F2D] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#234a26] transition-all duration-300 shadow-lg hover:shadow-xl"
//                 >
//                   <span>Get Directions</span>
//                   <ExternalLink className="w-5 h-5" />
//                 </a>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Final CTA */}
//       <section className="relative h-screen overflow-hidden">
//         <div 
//           className="absolute inset-0 bg-cover bg-center"
//           style={{
//             backgroundImage: `url('https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1920')`,
//           }}
//         ></div>

//         <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

//         <div className="relative z-10 h-full flex items-center justify-center px-6">
//           <div className="max-w-4xl mx-auto text-center text-white">
//             <h2 className="text-5xl md:text-7xl font-bold mb-6 drop-shadow-2xl">
//               Build Your Future
//             </h2>
//             <p className="text-2xl md:text-3xl text-white mb-4 font-light drop-shadow-lg">
//               Premium Villa Plots in Dandupally
//             </p>
//             <p className="text-xl text-white/90 mb-12 drop-shadow-lg">
//               Nagpur Highway - Northern Growth Corridor, Hyderabad
//             </p>

//             <div className="flex flex-col sm:flex-row gap-6 justify-center">
//               <button className="bg-white text-gray-900 px-10 py-5 rounded-lg font-bold hover:bg-gray-100 transition-all duration-300 shadow-2xl hover:shadow-3xl transform hover:-translate-y-1 text-lg flex items-center justify-center space-x-2">
//                 <Download className="w-6 h-6" />
//                 <span>Download Brochure</span>
//               </button>
//               <a 
//                 href="tel:+918885852266"
//                 className="bg-[#2C5F2D] border-2 border-[#2C5F2D] text-white px-10 py-5 rounded-lg font-bold hover:bg-[#234a26] hover:border-[#234a26] transition-all duration-300 shadow-2xl text-lg flex items-center justify-center space-x-2"
//               >
//                 <Phone className="w-6 h-6" />
//                 <span>Call: +91 8885852266</span>
//               </a>
//             </div>

//             <div className="mt-12 pt-12 border-t border-white/30">
//               <p className="text-white/90 mb-4 drop-shadow-lg">Contact Vedamsa Infrastructure</p>
//               <div className="flex flex-col sm:flex-row gap-6 justify-center text-white">
//                 <a href="tel:+918885852266" className="flex items-center justify-center space-x-2 hover:text-white/80 transition-colors drop-shadow-lg">
//                   <Phone className="w-5 h-5" />
//                   <span>+91 8885852266</span>
//                 </a>
//                 <a href="mailto:Vedamsa@gmail.com" className="flex items-center justify-center space-x-2 hover:text-white/80 transition-colors drop-shadow-lg">
//                   <Mail className="w-5 h-5" />
//                   <span>Vedamsa@gmail.com</span>
//                 </a>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Footer */}
//       {/* <footer className="bg-[#1a1a1a] text-white py-12 px-6">
//         <div className="max-w-7xl mx-auto">
//           <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
//             <div className="md:col-span-2">
//               <div className="flex items-center space-x-3 mb-4">
//                 <div className="bg-white text-gray-900 p-2 rounded">
//                   <Building2 className="w-6 h-6" />
//                 </div>
//                 <span className="text-2xl font-bold">Vedamsa</span>
//               </div>
//               <p className="text-gray-400 mb-4">Building Dreams, Creating Futures</p>
//               <p className="text-gray-500 text-sm">MAA Garudadri - Premium Villa Plots in Dandupally, Nagpur Highway</p>
//             </div>

//             <div>
//               <h4 className="font-bold mb-4">Quick Links</h4>
//               <div className="space-y-2 text-gray-400">
//                 <Link to="/" className="block hover:text-white transition-colors">Home</Link>
//                 <Link to="/about" className="block hover:text-white transition-colors">About Vedamsa</Link>
//                 <Link to="/contact" className="block hover:text-white transition-colors">Contact Us</Link>
//               </div>
//             </div>

//             <div>
//               <h4 className="font-bold mb-4">Contact</h4>
//               <div className="space-y-2 text-gray-400">
//                 <p>Dandupally, Hyderabad</p>
//                 <p>+91 8885852266</p>
//                 <p>Vedamsa@gmail.com</p>
//               </div>
//             </div>
//           </div>

//           <div className="border-t border-gray-700 pt-8 text-center">
//             <p className="text-gray-500 text-sm">© 2025 Vedamsa Infrastructure. All rights reserved. | MAA Garudadri</p>
//           </div>
//         </div>
//       </footer> */}
//     </div>
//   );
// };

// export default MaaGarudadriPage;



// import React, { useState, useEffect, useRef } from 'react';
// import { Link } from 'react-router-dom';
// import { 
//   Building2, 
//   MapPin, 
//   Download, 
//   CheckCircle, 
//   Home,
//   TreePine,
//   Shield,
//   Phone,
//   Mail,
//   ArrowRight,
//   ChevronDown,
//   Star,
//   TrendingUp,
//   Users,
//   Award,
//   ExternalLink,
//   Droplets,
//   Zap,
//   Ruler,
//   Lock,
//   ParkingCircle,
//   Activity,
//   Globe,
//   Briefcase,
//   GraduationCap,
//   Building,
//   Heart,
//   Clock,
//   Lightbulb
// } from 'lucide-react';
// import garudadri from  '../Images/garuda.png';
// import post1 from '../Images/g-post.png';
// import post2 from '../Images/g-post2.png';
// import post3 from '../Images/g-post3.png';
// import post4 from '../Images/Maa_Garudadri_page_1 (1).png';
// import road from '../Images/ES491735.jpg';

// // Reveal Image Component with Tailwind
// const RevealImage = ({ src, alt, className = "" }) => {
//   const wrapperRef = useRef();
//   const [isRevealed, setIsRevealed] = useState(false);

//   useEffect(() => {
//     const el = wrapperRef.current;
//     const observer = new IntersectionObserver(
//       entries => {
//         entries.forEach(entry => {
//           if (entry.isIntersecting) {
//             setIsRevealed(true);
//             observer.unobserve(el);
//           }
//         });
//       },
//       { threshold: 0.3 }
//     );
//     if (el) observer.observe(el);
//     return () => {
//       if (el) observer.unobserve(el);
//     };
//   }, []);
  
//   return (
//     <div ref={wrapperRef} className={`relative overflow-hidden ${className}`}>
//       <img 
//         src={src} 
//         alt={alt} 
//         className={`w-full h-full object-cover relative z-[1] transition-all duration-[1200ms] ease-out ${
//           isRevealed ? 'opacity-100 scale-100' : 'opacity-0 scale-110'
//         }`}
//         style={{ transitionDelay: '600ms' }}
//       />
//       <div 
//         className={`absolute top-0 left-0 w-full h-full bg-[#2C5F2D] z-[2] transition-transform duration-[1200ms] ${
//           isRevealed ? 'scale-x-0 origin-right' : 'scale-x-100 origin-left'
//         }`}
//         style={{ transitionTimingFunction: 'cubic-bezier(0.77, 0, 0.175, 1)' }}
//       />
//     </div>
//   );
// };

// // Reveal Content Component with Tailwind
// const RevealContent = ({ children, className = "", delay = 0 }) => {
//   const contentRef = useRef();
//   const [isRevealed, setIsRevealed] = useState(false);

//   useEffect(() => {
//     const el = contentRef.current;
//     const observer = new IntersectionObserver(
//       entries => {
//         entries.forEach(entry => {
//           if (entry.isIntersecting) {
//             setTimeout(() => {
//               setIsRevealed(true);
//             }, delay);
//             observer.unobserve(el);
//           }
//         });
//       },
//       { threshold: 0.1 }
//     );
//     if (el) observer.observe(el);
//     return () => {
//       if (el) observer.unobserve(el);
//     };
//   }, [delay]);
  
//   return (
//     <div 
//       ref={contentRef} 
//       className={`transition-all duration-800 ${
//         isRevealed ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-[30px]'
//       } ${className}`}
//       style={{ transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)' }}
//     >
//       {children}
//     </div>
//   );
// };

// const MaaGarudadriPage = () => {
//   const [scrolled, setScrolled] = useState(false);
//   const scrollContainerRef = useRef(null);

//   useEffect(() => {
//     const handleScroll = () => {
//       setScrolled(window.scrollY > 50);
//     };
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const highlights = [
//     { icon: <Home className="w-6 h-6" />, title: 'Villa Plots', subtitle: 'Premium Layouts' },
//     { icon: <MapPin className="w-6 h-6" />, title: 'Dandupally', subtitle: 'Nagpur Highway' },
//     { icon: <Building2 className="w-6 h-6" />, title: 'Vastu Compliant', subtitle: 'Perfect Design' },
//     { icon: <Star className="w-6 h-6" />, title: 'Value-Driven', subtitle: 'Competitive Price' }
//   ];

//   const features = [
//     {
//       icon: <Ruler className="w-8 h-8" />,
//       title: 'Vastu-Compliant Layouts',
//       desc: 'Ensuring harmony and prosperity in every plot'
//     },
//     {
//       icon: <ParkingCircle className="w-8 h-8" />,
//       title: 'Wide Roads',
//       desc: 'Modern infrastructure with 40-60 feet roads'
//     },
//     {
//       icon: <Zap className="w-8 h-8" />,
//       title: 'Underground Utilities',
//       desc: 'Power supply and drainage systems'
//     },
//     {
//       icon: <TreePine className="w-8 h-8" />,
//       title: 'Ample Green Spaces',
//       desc: 'Landscaped parks and gardens'
//     },
//     {
//       icon: <Shield className="w-8 h-8" />,
//       title: '24/7 Security',
//       desc: 'Secure gated community with CCTV'
//     },
//     {
//       icon: <Droplets className="w-8 h-8" />,
//       title: 'Rainwater Harvesting',
//       desc: 'Environmentally conscious development'
//     },
//     {
//       icon: <Activity className="w-8 h-8" />,
//       title: 'Fitness Zones',
//       desc: 'Jogging tracks and outdoor gym'
//     },
//     {
//       icon: <Lock className="w-8 h-8" />,
//       title: 'Gated Community',
//       desc: 'Complete peace of mind for residents'
//     }
//   ];

//   const advantages = [
//     {
//       icon: <TrendingUp className="w-10 h-10" />,
//       title: 'Strategic Growth Corridor',
//       desc: 'Connects Hyderabad to major cities, making it ideal for residential and commercial developments'
//     },
//     {
//       icon: <Building2 className="w-10 h-10" />,
//       title: 'Infrastructure Boom',
//       desc: 'Government focus on industrial corridors, logistics hubs, and upgraded roads'
//     },
//     {
//       icon: <Award className="w-10 h-10" />,
//       title: 'Future-Ready Location',
//       desc: "Dandupally's strategic location ensures high returns on investment"
//     },
//     {
//       icon: <Users className="w-10 h-10" />,
//       title: 'Planned Community Living',
//       desc: 'Landscaped parks, fitness zones, and modern amenities for comfortable living'
//     }
//   ];

//   return (
//     <div className="min-h-screen bg-[#f5f3f0]">
//       {/* Hero Section */}
//       <section className="relative h-screen w-full overflow-hidden">
//         <div 
//           className="absolute inset-0 bg-cover bg-center"
//           style={{
//             backgroundImage: `url(${garudadri})`,
//           }}
//         ></div>

//         <div className="relative z-20 h-full flex items-center">
//           <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
//             <div className="max-w-3xl">
//               <RevealContent delay={100}>
//                 <div className="inline-block mb-4 sm:mb-6 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 sm:px-6 py-2">
//                   <span className="text-white text-xs sm:text-sm font-medium">By Vedamsa - 30 Years of Excellence</span>
//                 </div>
//               </RevealContent>

//               <RevealContent delay={200}>
//                 <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-4 sm:mb-6 leading-tight">
//                   MAA Garudadri
//                 </h1>
//               </RevealContent>
              
//               <RevealContent delay={300}>
//                 <p className="text-xl sm:text-2xl md:text-3xl text-white/90 mb-3 sm:mb-4 font-light">
//                   Premium Villa Plots
//                 </p>
//               </RevealContent>
              
//               <RevealContent delay={400}>
//                 <p className="text-lg sm:text-xl text-white/80 mb-6 sm:mb-8">
//                   Dandupally, Nagpur Highway (NH-44)
//                 </p>
//               </RevealContent>

//               <RevealContent delay={500}>
//                 <div className="inline-block bg-white rounded-2xl px-6 sm:px-8 py-3 sm:py-4 mb-8 sm:mb-10 shadow-2xl">
//                   <p className="text-gray-600 text-xs sm:text-sm mb-1">Northern Growth Corridor</p>
//                   <p className="text-xl sm:text-2xl font-bold text-[#2C5F2D]">Hyderabad's Prime Location</p>
//                 </div>
//               </RevealContent>

//               <RevealContent delay={600}>
//                 <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
//                   <button className="group bg-white text-gray-900 px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-bold hover:bg-gray-100 transition-all duration-300 shadow-xl hover:shadow-2xl transform hover:-translate-y-1 flex items-center justify-center space-x-2">
//                     <Download className="w-4 h-4 sm:w-5 sm:h-5" />
//                     <span className="text-sm sm:text-base">Download Brochure</span>
//                   </button>
//                   <a 
//                     href="tel:+918885852266"
//                     className="bg-transparent border-2 border-white text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-bold hover:bg-white hover:text-gray-900 transition-all duration-300 flex items-center justify-center space-x-2"
//                   >
//                     <Phone className="w-4 h-4 sm:w-5 sm:h-5" />
//                     <span className="text-sm sm:text-base">Schedule Site Visit</span>
//                   </a>
//                 </div>
//               </RevealContent>
//             </div>
//           </div>
//         </div>

//         <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20 animate-bounce">
//           <ChevronDown className="w-6 h-6 sm:w-8 sm:h-8 text-white/60" />
//         </div>
//       </section>

//       {/* Quick Highlights Bar */}
//       <section className="bg-white py-6 sm:py-8 shadow-lg relative z-30 -mt-20">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-6">
//             {highlights.map((item, index) => (
//               <RevealContent key={index} delay={index * 100}>
//                 <div className="flex items-center space-x-2 sm:space-x-4 p-3 sm:p-4 bg-[#f5f3f0] rounded-lg hover:shadow-md transition-shadow duration-300">
//                   <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-[#2C5F2D] text-white rounded-lg flex items-center justify-center">
//                     {item.icon}
//                   </div>
//                   <div>
//                     <p className="font-bold text-gray-900 text-sm sm:text-base">{item.title}</p>
//                     <p className="text-xs sm:text-sm text-gray-600">{item.subtitle}</p>
//                   </div>
//                 </div>
//               </RevealContent>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* About Section */}
//       <section className="py-12 sm:py-20 px-4 sm:px-6 lg:px-8 bg-[#f5f3f0]">
//         <div className="max-w-7xl mx-auto">
//           <div className="text-center mb-12 sm:mb-16">
//             <RevealContent>
//               <span className="text-xs sm:text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-4 sm:mb-6 block">
//                 [WELCOME TO]
//               </span>
//             </RevealContent>
//             <RevealContent delay={100}>
//               <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
//                 Your Dream Villa Awaits
//               </h2>
//             </RevealContent>
//             <RevealContent delay={200}>
//               <p className="text-gray-600 text-base sm:text-lg leading-relaxed max-w-4xl mx-auto px-4">
//                 Welcome to MAA GARUDADRI, a prestigious villa plot project by Vedamsa, a trusted name in Hyderabad's real estate market with over 30 years of expertise. Strategically located in Dandupally, along the thriving Nagpur Highway, MAA GARUDADRI offers the perfect opportunity for those looking to invest in premium real estate within the Northern Growth Corridor of Hyderabad.
//               </p>
//             </RevealContent>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6">
//             <div className="md:col-span-2 relative overflow-hidden rounded-2xl shadow-2xl group h-[300px] sm:h-[400px] lg:h-[500px]">
//               <RevealImage 
//                 src={post3}
//                 alt="Premium Villa"
//                 className="w-full h-full"
//               />
//               <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
//               <div className="absolute bottom-4 sm:bottom-6 left-4 sm:left-6 text-white">
//                 <p className="text-lg sm:text-2xl font-bold">Premium Villa Plots</p>
//                 <p className="text-sm sm:text-base text-white/80">Build Your Dream Home</p>
//               </div>
//             </div>

//             <div className="space-y-4 sm:space-y-6">
//               <div className="relative overflow-hidden rounded-2xl shadow-xl group h-[145px] sm:h-[190px] lg:h-[237px]">
//                 <RevealImage 
//                   src={post2}
//                   alt="Gated Community"
//                   className="w-full h-full"
//                 />
//                 <div className="absolute inset-0 bg-black/30"></div>
//                 <div className="absolute bottom-3 sm:bottom-4 left-3 sm:left-4 text-white">
//                   <p className="text-base sm:text-lg font-bold">Gated Community</p>
//                 </div>
//               </div>
//               <div className="relative overflow-hidden rounded-2xl shadow-xl group h-[145px] sm:h-[190px] lg:h-[237px]">
//                 <RevealImage 
//                   src="https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=600"
//                   alt="Green Spaces"
//                   className="w-full h-full"
//                 />
//                 <div className="absolute inset-0 bg-black/30"></div>
//                 <div className="absolute bottom-3 sm:bottom-4 left-3 sm:left-4 text-white">
//                   <p className="text-base sm:text-lg font-bold">Green Spaces</p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Why Choose MAA GARUDADRI Section */}
//       <section className="py-12 sm:py-20 px-4 sm:px-6 lg:px-8 bg-white">
//         <div className="max-w-7xl mx-auto">
//           <div className="text-center mb-12 sm:mb-16">
//             <RevealContent>
//               <span className="text-xs sm:text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-4 sm:mb-6 block">
//                 [WHY CHOOSE US]
//               </span>
//             </RevealContent>
//             <RevealContent delay={100}>
//               <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
//                 Why Choose MAA GARUDADRI?
//               </h2>
//             </RevealContent>
//             <RevealContent delay={200}>
//               <h3 className="text-xl sm:text-2xl font-semibold text-[#2C5F2D] mb-6 sm:mb-8">
//                 Prime Location: Dandupally, Nagpur Highway
//               </h3>
//             </RevealContent>
//             <RevealContent delay={300}>
//               <p className="text-gray-600 text-base sm:text-lg leading-relaxed max-w-4xl mx-auto px-4">
//                 MAA GARUDADRI is nestled in Dandupally, a rapidly developing region along the Nagpur Highway (NH-44). This area is part of Hyderabad's Northern Growth Corridor, which has become a real estate hotspot due to its excellent connectivity and infrastructure development.
//               </p>
//             </RevealContent>
//           </div>

//           {/* Three Feature Cards */}
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 mb-12">
//             {/* Seamless Connectivity */}
//             <RevealContent delay={100}>
//               <div className="bg-[#f5f3f0] rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
//                 <div className="relative h-48 sm:h-56 lg:h-64 overflow-hidden">
//                   <RevealImage 
//                     src={road}
//                     alt="Seamless Connectivity"
//                     className="w-full h-full"
//                   />
//                   <div className="absolute inset-0 bg-gradient-to-t from-[#2C5F2D]/80 via-transparent to-transparent"></div>
//                   <div className="absolute bottom-3 sm:bottom-4 left-3 sm:left-4">
//                     <div className="w-10 h-10 sm:w-12 sm:h-12 bg-white rounded-lg flex items-center justify-center mb-2">
//                       <Globe className="w-5 h-5 sm:w-6 sm:h-6 text-[#2C5F2D]" />
//                     </div>
//                   </div>
//                 </div>
//                 <div className="p-4 sm:p-6">
//                   <h4 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">Seamless Connectivity</h4>
//                   <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
//                     Close proximity to ORR, IT hubs, and industrial zones ensuring easy commute and excellent accessibility
//                   </p>
//                 </div>
//               </div>
//             </RevealContent>

//             {/* Urban Amenities */}
//             <RevealContent delay={200}>
//               <div className="bg-[#f5f3f0] rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
//                 <div className="relative h-48 sm:h-56 lg:h-64 overflow-hidden">
//                   <RevealImage 
//                     src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=600"
//                     alt="Urban Amenities"
//                     className="w-full h-full"
//                   />
//                   <div className="absolute inset-0 bg-gradient-to-t from-[#2C5F2D]/80 via-transparent to-transparent"></div>
//                   <div className="absolute bottom-3 sm:bottom-4 left-3 sm:left-4">
//                     <div className="w-10 h-10 sm:w-12 sm:h-12 bg-white rounded-lg flex items-center justify-center mb-2">
//                       <Building className="w-5 h-5 sm:w-6 sm:h-6 text-[#2C5F2D]" />
//                     </div>
//                   </div>
//                 </div>
//                 <div className="p-4 sm:p-6">
//                   <h4 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">Access to Urban Amenities</h4>
//                   <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
//                     Educational institutions, hospitals, and shopping centers within easy reach for your convenience
//                   </p>
//                 </div>
//               </div>
//             </RevealContent>

//             {/* Future Growth */}
//             <RevealContent delay={300}>
//               <div className="bg-[#f5f3f0] rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
//                 <div className="relative h-48 sm:h-56 lg:h-64 overflow-hidden">
//                   <RevealImage 
//                     src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600"
//                     alt="Future Growth"
//                     className="w-full h-full"
//                   />
//                   <div className="absolute inset-0 bg-gradient-to-t from-[#2C5F2D]/80 via-transparent to-transparent"></div>
//                   <div className="absolute bottom-3 sm:bottom-4 left-3 sm:left-4">
//                     <div className="w-10 h-10 sm:w-12 sm:h-12 bg-white rounded-lg flex items-center justify-center mb-2">
//                       <TrendingUp className="w-5 h-5 sm:w-6 sm:h-6 text-[#2C5F2D]" />
//                     </div>
//                   </div>
//                 </div>
//                 <div className="p-4 sm:p-6">
//                   <h4 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">Future Growth Potential</h4>
//                   <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
//                     Proximity to key projects like Pharma City and Aerospace SEZ enhances the value of the region
//                   </p>
//                 </div>
//               </div>
//             </RevealContent>
//           </div>

//           <RevealContent delay={400}>
//             <div className="text-center">
//               <p className="text-gray-700 text-base sm:text-lg font-medium max-w-3xl mx-auto px-4">
//                 For those looking for villa plots for sale in Nagpur Highway, this location combines urban convenience with serene living.
//               </p>
//             </div>
//           </RevealContent>
//         </div>
//       </section>

//       {/* Vedamsa's Trusted Legacy Section */}
//       <section className="py-12 sm:py-20 px-4 sm:px-6 lg:px-8 bg-[#f5f3f0]">
//         <div className="max-w-7xl mx-auto">
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
//             {/* Left - Image */}
//             <div className="relative overflow-hidden rounded-2xl shadow-2xl group h-[400px] sm:h-[500px] lg:h-[600px] order-2 lg:order-1">
//               <RevealImage 
//                 src={post1}
//                 alt="Vedamsa Legacy"
//                 className="w-full h-full"
//               />
//               <div className="absolute inset-0 bg-gradient-to-t from-[#2C5F2D]/70 via-transparent to-transparent"></div>
//               <div className="absolute bottom-6 sm:bottom-8 left-6 sm:left-8 text-white">
//                 <Award className="w-8 h-8 sm:w-10 sm:h-10 mb-2" />
//                 <p className="text-2xl sm:text-3xl font-bold">30+ Years</p>
//                 <p className="text-sm sm:text-base text-white/80">of Excellence & Trust</p>
//               </div>
//             </div>

//             {/* Right - Content */}
//             <div className="order-1 lg:order-2">
//               <RevealContent>
//                 <span className="text-xs sm:text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-4 sm:mb-6 block">
//                   [TRUSTED DEVELOPER]
//                 </span>
//               </RevealContent>
//               <RevealContent delay={100}>
//                 <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
//                   Vedamsa's Trusted Legacy
//                 </h2>
//               </RevealContent>
//               <RevealContent delay={200}>
//                 <p className="text-gray-600 text-base sm:text-lg leading-relaxed mb-6 sm:mb-8">
//                   With more than three decades of experience in delivering quality projects, Vedamsa has earned the trust of over 3000 happy customers. When you invest in MAA GARUDADRI, you're choosing a developer known for:
//                 </p>
//               </RevealContent>

//               <div className="space-y-3 sm:space-y-4">
//                 <RevealContent delay={300}>
//                   <div className="flex items-start space-x-3 sm:space-x-4 p-3 sm:p-4 bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300">
//                     <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-[#2C5F2D]/10 rounded-lg flex items-center justify-center">
//                       <Award className="w-5 h-5 sm:w-6 sm:h-6 text-[#2C5F2D]" />
//                     </div>
//                     <div>
//                       <h4 className="font-bold text-gray-900 mb-1 text-sm sm:text-base">Uncompromising Quality</h4>
//                       <p className="text-gray-600 text-xs sm:text-sm">Every project built to the highest standards</p>
//                     </div>
//                   </div>
//                 </RevealContent>

//                 <RevealContent delay={400}>
//                   <div className="flex items-start space-x-3 sm:space-x-4 p-3 sm:p-4 bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300">
//                     <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-[#2C5F2D]/10 rounded-lg flex items-center justify-center">
//                       <CheckCircle className="w-5 h-5 sm:w-6 sm:h-6 text-[#2C5F2D]" />
//                     </div>
//                     <div>
//                       <h4 className="font-bold text-gray-900 mb-1 text-sm sm:text-base">Transparent Processes</h4>
//                       <p className="text-gray-600 text-xs sm:text-sm">Complete clarity in every transaction</p>
//                     </div>
//                   </div>
//                 </RevealContent>

//                 <RevealContent delay={500}>
//                   <div className="flex items-start space-x-3 sm:space-x-4 p-3 sm:p-4 bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300">
//                     <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-[#2C5F2D]/10 rounded-lg flex items-center justify-center">
//                       <Clock className="w-5 h-5 sm:w-6 sm:h-6 text-[#2C5F2D]" />
//                     </div>
//                     <div>
//                       <h4 className="font-bold text-gray-900 mb-1 text-sm sm:text-base">Timely Deliveries</h4>
//                       <p className="text-gray-600 text-xs sm:text-sm">Committed to meeting deadlines</p>
//                     </div>
//                   </div>
//                 </RevealContent>

//                 <RevealContent delay={600}>
//                   <div className="flex items-start space-x-3 sm:space-x-4 p-3 sm:p-4 bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300">
//                     <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-[#2C5F2D]/10 rounded-lg flex items-center justify-center">
//                       <Heart className="w-5 h-5 sm:w-6 sm:h-6 text-[#2C5F2D]" />
//                     </div>
//                     <div>
//                       <h4 className="font-bold text-gray-900 mb-1 text-sm sm:text-base">Customer-Centric Approach</h4>
//                       <p className="text-gray-600 text-xs sm:text-sm">Your satisfaction is our priority</p>
//                     </div>
//                   </div>
//                 </RevealContent>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Premium Villa Plots Section */}
//       <section className="py-12 sm:py-20 px-4 sm:px-6 lg:px-8 bg-white">
//         <div className="max-w-7xl mx-auto">
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
//             {/* Left - Content */}
//             <div>
//               <RevealContent>
//                 <span className="text-xs sm:text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-4 sm:mb-6 block">
//                   [PREMIUM PLOTS]
//                 </span>
//               </RevealContent>
//               <RevealContent delay={100}>
//                 <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
//                   Premium Villa Plots with Infinite Possibilities
//                 </h2>
//               </RevealContent>
//               <RevealContent delay={200}>
//                 <p className="text-gray-600 text-base sm:text-lg leading-relaxed mb-6 sm:mb-8">
//                   MAA GARUDADRI offers meticulously planned villa plots that are perfect for building your dream home or making a secure investment. Key features include:
//                 </p>
//               </RevealContent>

//               <div className="space-y-4 sm:space-y-6">
//                 <RevealContent delay={300}>
//                   <div className="flex items-start space-x-3 sm:space-x-4">
//                     <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-[#2C5F2D] text-white rounded-lg flex items-center justify-center">
//                       <Ruler className="w-5 h-5 sm:w-6 sm:h-6" />
//                     </div>
//                     <div>
//                       <h4 className="font-bold text-gray-900 mb-1 sm:mb-2 text-sm sm:text-base">Vastu-Compliant Layouts</h4>
//                       <p className="text-gray-600 text-xs sm:text-sm">Ensuring harmony and prosperity in every aspect of your home</p>
//                     </div>
//                   </div>
//                 </RevealContent>

//                 <RevealContent delay={400}>
//                   <div className="flex items-start space-x-3 sm:space-x-4">
//                     <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-[#2C5F2D] text-white rounded-lg flex items-center justify-center">
//                       <Building2 className="w-5 h-5 sm:w-6 sm:h-6" />
//                     </div>
//                     <div>
//                       <h4 className="font-bold text-gray-900 mb-1 sm:mb-2 text-sm sm:text-base">Modern Infrastructure</h4>
//                       <p className="text-gray-600 text-xs sm:text-sm">Wide roads, underground utilities, and ample green spaces</p>
//                     </div>
//                   </div>
//                 </RevealContent>

//                 <RevealContent delay={500}>
//                   <div className="flex items-start space-x-3 sm:space-x-4">
//                     <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-[#2C5F2D] text-white rounded-lg flex items-center justify-center">
//                       <Shield className="w-5 h-5 sm:w-6 sm:h-6" />
//                     </div>
//                     <div>
//                       <h4 className="font-bold text-gray-900 mb-1 sm:mb-2 text-sm sm:text-base">Secure Gated Community</h4>
//                       <p className="text-gray-600 text-xs sm:text-sm">24/7 security for complete peace of mind</p>
//                     </div>
//                   </div>
//                 </RevealContent>
//               </div>

//               <RevealContent delay={600}>
//                 <div className="mt-6 sm:mt-8 p-4 sm:p-6 bg-[#f5f3f0] rounded-xl border-l-4 border-[#2C5F2D]">
//                   <p className="text-gray-700 font-medium text-sm sm:text-base">
//                     Whether you're seeking to buy villa plots in Nagpur Highway for residential or investment purposes, MAA GARUDADRI offers a future-ready solution.
//                   </p>
//                 </div>
//               </RevealContent>
//             </div>

//             {/* Right - Image */}
//             <div className="relative overflow-hidden rounded-2xl shadow-2xl group h-[400px] sm:h-[500px] lg:h-[600px]">
//               <RevealImage 
//                 src={post4}
//                 alt="Villa Plot Layout"
//                 className="w-full h-full"
//               />
//               <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
//               <div className="absolute bottom-6 sm:bottom-8 left-6 sm:left-8 right-6 sm:right-8">
//                 <div className="bg-white/95 backdrop-blur-sm rounded-xl p-4 sm:p-6">
//                   <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2">Build Your Dream</h3>
//                   <p className="text-sm sm:text-base text-gray-600">Flexible plots for custom villa designs</p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* What Sets MAA GARUDADRI Apart Section */}
//       <section className="py-12 sm:py-20 px-4 sm:px-6 lg:px-8 bg-gray-900 text-white">
//         <div className="max-w-7xl mx-auto">
//           <div className="text-center mb-12 sm:mb-16">
//             <RevealContent>
//               <span className="text-xs sm:text-sm uppercase tracking-[0.3em] text-gray-400 font-medium mb-4 sm:mb-6 block">
//                 [WHAT SETS US APART]
//               </span>
//             </RevealContent>
//             <RevealContent delay={100}>
//               <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 sm:mb-6">
//                 What Sets MAA GARUDADRI Apart?
//               </h2>
//             </RevealContent>
//             <RevealContent delay={200}>
//               <p className="text-gray-300 text-base sm:text-lg max-w-3xl mx-auto px-4">
//                 Experience the difference with our comprehensive community features and environmentally conscious development
//               </p>
//             </RevealContent>
//           </div>

//           <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 sm:gap-8">
//             {/* Planned Community Living */}
//             <RevealContent delay={100}>
//               <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl overflow-hidden hover:bg-white/10 transition-all duration-300">
//                 <div className="relative h-48 sm:h-56 lg:h-64 overflow-hidden">
//                   <RevealImage 
//                     src="https://images.unsplash.com/photo-1587582423116-ec07293f0395?w=600"
//                     alt="Community Living"
//                     className="w-full h-full"
//                   />
//                   <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent"></div>
//                   <div className="absolute bottom-3 sm:bottom-4 left-3 sm:left-4">
//                     <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#2C5F2D] rounded-lg flex items-center justify-center">
//                       <Users className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
//                     </div>
//                   </div>
//                 </div>
//                 <div className="p-4 sm:p-6">
//                   <h3 className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4">1. Planned Community Living</h3>
//                   <ul className="space-y-2 sm:space-y-3 text-gray-300">
//                     <li className="flex items-start space-x-2">
//                       <CheckCircle className="w-4 h-4 sm:w-5 sm:h-5 text-[#4A7C59] flex-shrink-0 mt-0.5" />
//                       <span className="text-sm sm:text-base">Landscaped parks, jogging tracks, fitness zones</span>
//                     </li>
//                     <li className="flex items-start space-x-2">
//                       <CheckCircle className="w-4 h-4 sm:w-5 sm:h-5 text-[#4A7C59] flex-shrink-0 mt-0.5" />
//                       <span className="text-sm sm:text-base">Underground drainage & power supply</span>
//                     </li>
//                     <li className="flex items-start space-x-2">
//                       <CheckCircle className="w-4 h-4 sm:w-5 sm:h-5 text-[#4A7C59] flex-shrink-0 mt-0.5" />
//                       <span className="text-sm sm:text-base">24/7 security services</span>
//                     </li>
//                   </ul>
//                 </div>
//               </div>
//             </RevealContent>

//             {/* Flexibility in Design */}
//             <RevealContent delay={200}>
//               <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl overflow-hidden hover:bg-white/10 transition-all duration-300">
//                 <div className="relative h-48 sm:h-56 lg:h-64 overflow-hidden">
//                   <RevealImage 
//                     src="https://images.unsplash.com/photo-1503174971373-b1f69850bded?w=600"
//                     alt="Design Flexibility"
//                     className="w-full h-full"
//                   />
//                   <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent"></div>
//                   <div className="absolute bottom-3 sm:bottom-4 left-3 sm:left-4">
//                     <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#2C5F2D] rounded-lg flex items-center justify-center">
//                       <Lightbulb className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
//                     </div>
//                   </div>
//                 </div>
//                 <div className="p-4 sm:p-6">
//                   <h3 className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4">2. Flexibility in Design</h3>
//                   <ul className="space-y-2 sm:space-y-3 text-gray-300">
//                     <li className="flex items-start space-x-2">
//                       <CheckCircle className="w-4 h-4 sm:w-5 sm:h-5 text-[#4A7C59] flex-shrink-0 mt-0.5" />
//                       <span className="text-sm sm:text-base">Villa plots allowing you to build your dream home</span>
//                     </li>
//                     <li className="flex items-start space-x-2">
//                       <CheckCircle className="w-4 h-4 sm:w-5 sm:h-5 text-[#4A7C59] flex-shrink-0 mt-0.5" />
//                       <span className="text-sm sm:text-base">Customizable layouts to suit your needs</span>
//                     </li>
//                     <li className="flex items-start space-x-2">
//                       <CheckCircle className="w-4 h-4 sm:w-5 sm:h-5 text-[#4A7C59] flex-shrink-0 mt-0.5" />
//                       <span className="text-sm sm:text-base">Freedom to create your perfect living space</span>
//                     </li>
//                   </ul>
//                 </div>
//               </div>
//             </RevealContent>

//             {/* Environmentally Conscious */}
//             <RevealContent delay={300}>
//               <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl overflow-hidden hover:bg-white/10 transition-all duration-300">
//                 <div className="relative h-48 sm:h-56 lg:h-64 overflow-hidden">
//                   <RevealImage 
//                     src="https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?w=600"
//                     alt="Environmental"
//                     className="w-full h-full"
//                   />
//                   <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent"></div>
//                   <div className="absolute bottom-3 sm:bottom-4 left-3 sm:left-4">
//                     <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#2C5F2D] rounded-lg flex items-center justify-center">
//                       <TreePine className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
//                     </div>
//                   </div>
//                 </div>
//                 <div className="p-4 sm:p-6">
//                   <h3 className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4">3. Environmentally Conscious</h3>
//                   <ul className="space-y-2 sm:space-y-3 text-gray-300">
//                     <li className="flex items-start space-x-2">
//                       <CheckCircle className="w-4 h-4 sm:w-5 sm:h-5 text-[#4A7C59] flex-shrink-0 mt-0.5" />
//                       <span className="text-sm sm:text-base">Rainwater harvesting systems</span>
//                     </li>
//                     <li className="flex items-start space-x-2">
//                       <CheckCircle className="w-4 h-4 sm:w-5 sm:h-5 text-[#4A7C59] flex-shrink-0 mt-0.5" />
//                       <span className="text-sm sm:text-base">Energy-efficient lighting throughout</span>
//                     </li>
//                     <li className="flex items-start space-x-2">
//                       <CheckCircle className="w-4 h-4 sm:w-5 sm:h-5 text-[#4A7C59] flex-shrink-0 mt-0.5" />
//                       <span className="text-sm sm:text-base">Extensive plantation and green cover</span>
//                     </li>
//                   </ul>
//                 </div>
//               </div>
//             </RevealContent>
//           </div>
//         </div>
//       </section>

//       {/* Features Section */}
//       <section className="py-12 sm:py-20 px-4 sm:px-6 lg:px-8 bg-[#f5f3f0]">
//         <div className="max-w-7xl mx-auto">
//           <div className="text-center mb-12 sm:mb-16">
//             <RevealContent>
//               <span className="text-xs sm:text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-4 sm:mb-6 block">
//                 [PREMIUM FEATURES]
//               </span>
//             </RevealContent>
//             <RevealContent delay={100}>
//               <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
//                 World-Class Amenities
//               </h2>
//             </RevealContent>
//             <RevealContent delay={200}>
//               <p className="text-gray-600 text-base sm:text-lg leading-relaxed max-w-3xl mx-auto px-4">
//                 Experience modern living with comprehensive facilities designed for your comfort and convenience
//               </p>
//             </RevealContent>
//           </div>

//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
//             {features.map((feature, index) => (
//               <RevealContent key={index} delay={index * 100}>
//                 <div className="bg-white p-4 sm:p-6 rounded-xl hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
//                   <div className="w-12 h-12 sm:w-16 sm:h-16 bg-[#2C5F2D]/10 text-[#2C5F2D] rounded-xl flex items-center justify-center mb-3 sm:mb-4">
//                     {feature.icon}
//                   </div>
//                   <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">{feature.title}</h3>
//                   <p className="text-gray-600 text-xs sm:text-sm">{feature.desc}</p>
//                 </div>
//               </RevealContent>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Investment Advantages */}
//       <section className="py-12 sm:py-20 px-4 sm:px-6 lg:px-8 bg-white">
//         <div className="max-w-7xl mx-auto">
//           <div className="text-center mb-12 sm:mb-16">
//             <RevealContent>
//               <span className="text-xs sm:text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-4 sm:mb-6 block">
//                 [WHY INVEST]
//               </span>
//             </RevealContent>
//             <RevealContent delay={100}>
//               <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
//                 Why Invest in Villa Plots<br className="hidden sm:block" />on Nagpur Highway?
//               </h2>
//             </RevealContent>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
//             {advantages.map((advantage, index) => (
//               <RevealContent key={index} delay={index * 150}>
//                 <div className="bg-[#f5f3f0] p-6 sm:p-8 rounded-2xl hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
//                   <div className="w-16 h-16 sm:w-20 sm:h-20 bg-white text-[#2C5F2D] rounded-xl flex items-center justify-center mb-4 sm:mb-6 shadow-md">
//                     {advantage.icon}
//                   </div>
//                   <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4">{advantage.title}</h3>
//                   <p className="text-gray-600 leading-relaxed text-sm sm:text-base">{advantage.desc}</p>
//                 </div>
//               </RevealContent>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Location Map */}
//       <section className="py-12 sm:py-20 px-4 sm:px-6 lg:px-8 bg-[#f5f3f0]">
//         <div className="max-w-7xl mx-auto">
//           <div className="text-center mb-8 sm:mb-12">
//             <RevealContent>
//               <span className="text-xs sm:text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-4 sm:mb-6 block">
//                 [LOCATION]
//               </span>
//             </RevealContent>
//             <RevealContent delay={100}>
//               <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
//                 Find Us Here
//               </h2>
//             </RevealContent>
//           </div>

//           <RevealContent delay={200}>
//             <div className="relative overflow-hidden rounded-2xl shadow-2xl h-[400px] sm:h-[500px] group">
//               <iframe
//                 src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3804.7441616893837!2d78.19588450000001!3d17.5527712!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcbf12a5f2662cf%3A0xc385d29a5612e332!2sVedamsa%20Infrastructure%20pvt%20ltd!5e0!3m2!1sen!2sus!4v1234567890123!5m2!1sen!2sus"
//                 width="100%"
//                 height="100%"
//                 style={{ border: 0 }}
//                 allowFullScreen=""
//                 loading="lazy"
//                 referrerPolicy="no-referrer-when-downgrade"
//                 className="w-full h-full"
//               ></iframe>
              
//               <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent pointer-events-none"></div>
//               <div className="absolute bottom-4 sm:bottom-8 left-4 sm:left-8 right-4 sm:right-8 pointer-events-auto">
//                 <div className="bg-white/95 backdrop-blur-sm rounded-xl p-4 sm:p-6 shadow-2xl">
//                   <div className="flex items-start justify-between flex-col sm:flex-row">
//                     <div className="flex-1 mb-4 sm:mb-0">
//                       <MapPin className="w-6 h-6 sm:w-8 sm:h-8 text-[#2C5F2D] mb-2" />
//                       <p className="text-xl sm:text-2xl font-bold text-gray-900 mb-2">MAA Garudadri, Dandupally</p>
//                       <p className="text-sm sm:text-base text-gray-600 mb-4">Nagpur Highway (NH-44), Hyderabad</p>
//                     </div>
//                   </div>
//                   <a 
//                     href="https://www.google.com/maps/place/Vedamsa+Infrastructure+pvt+ltd/@17.552771,78.195885,10z/data=!4m6!3m5!1s0x3bcbf12a5f2662cf:0xc385d29a5612e332!8m2!3d17.5527712!4d78.1958845!16s%2Fg%2F11vyt53tgr?hl=en-US&entry=ttu&g_ep=EgoyMDI1MTIwOS4wIKXMDSoASAFQAw%3D%3D"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="inline-flex items-center space-x-2 bg-[#2C5F2D] text-white px-4 sm:px-6 py-2 sm:py-3 rounded-lg font-semibold hover:bg-[#234a26] transition-all duration-300 shadow-lg hover:shadow-xl text-sm sm:text-base"
//                   >
//                     <span>Get Directions</span>
//                     <ExternalLink className="w-4 h-4 sm:w-5 sm:h-5" />
//                   </a>
//                 </div>
//               </div>
//             </div>
//           </RevealContent>
//         </div>
//       </section>

//       {/* Final CTA */}
//       <section className="relative h-screen overflow-hidden">
//         <div 
//           className="absolute inset-0 bg-cover bg-center"
//           style={{
//             backgroundImage: `url('https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1920')`,
//           }}
//         ></div>

//         <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

//         <div className="relative z-10 h-full flex items-center justify-center px-4 sm:px-6">
//           <div className="max-w-4xl mx-auto text-center text-white">
//             <RevealContent>
//               <h2 className="text-4xl sm:text-5xl md:text-7xl font-bold mb-4 sm:mb-6 drop-shadow-2xl">
//                 Build Your Future
//               </h2>
//             </RevealContent>
//             <RevealContent delay={100}>
//               <p className="text-xl sm:text-2xl md:text-3xl text-white mb-3 sm:mb-4 font-light drop-shadow-lg">
//                 Premium Villa Plots in Dandupally
//               </p>
//             </RevealContent>
//             <RevealContent delay={200}>
//               <p className="text-lg sm:text-xl text-white/90 mb-8 sm:mb-12 drop-shadow-lg">
//                 Nagpur Highway - Northern Growth Corridor, Hyderabad
//               </p>
//             </RevealContent>

//             <RevealContent delay={300}>
//               <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center">
//                 <button className="bg-white text-gray-900 px-8 sm:px-10 py-4 sm:py-5 rounded-lg font-bold hover:bg-gray-100 transition-all duration-300 shadow-2xl hover:shadow-3xl transform hover:-translate-y-1 text-base sm:text-lg flex items-center justify-center space-x-2">
//                   <Download className="w-5 h-5 sm:w-6 sm:h-6" />
//                   <span>Download Brochure</span>
//                 </button>
//                 <a 
//                   href="tel:+918885852266"
//                   className="bg-[#2C5F2D] border-2 border-[#2C5F2D] text-white px-8 sm:px-10 py-4 sm:py-5 rounded-lg font-bold hover:bg-[#234a26] hover:border-[#234a26] transition-all duration-300 shadow-2xl text-base sm:text-lg flex items-center justify-center space-x-2"
//                 >
//                   <Phone className="w-5 h-5 sm:w-6 sm:h-6" />
//                   <span className="hidden sm:inline">Call: +91 8885852266</span>
//                   <span className="sm:hidden">Call Now</span>
//                 </a>
//               </div>
//             </RevealContent>

//             <RevealContent delay={400}>
//               <div className="mt-8 sm:mt-12 pt-8 sm:pt-12 border-t border-white/30">
//                 <p className="text-white/90 mb-4 drop-shadow-lg text-sm sm:text-base">Contact Vedamsa Infrastructure</p>
//                 <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center text-white">
//                   <a href="tel:+918885852266" className="flex items-center justify-center space-x-2 hover:text-white/80 transition-colors drop-shadow-lg text-sm sm:text-base">
//                     <Phone className="w-4 h-4 sm:w-5 sm:h-5" />
//                     <span>+91 8885852266</span>
//                   </a>
//                   <a href="mailto:Vedamsa@gmail.com" className="flex items-center justify-center space-x-2 hover:text-white/80 transition-colors drop-shadow-lg text-sm sm:text-base">
//                     <Mail className="w-4 h-4 sm:w-5 sm:h-5" />
//                     <span>Vedamsa@gmail.com</span>
//                   </a>
//                 </div>
//               </div>
//             </RevealContent>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default MaaGarudadriPage;


import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { 
  Building2, 
  MapPin, 
  Download, 
  CheckCircle, 
  Home,
  TreePine,
  Shield,
  Phone,
  Mail,
  ArrowRight,
  ChevronDown,
  Star,
  TrendingUp,
  Users,
  Award,
  ExternalLink,
  Droplets,
  Zap,
  Ruler,
  Lock,
  ParkingCircle,
  Activity,
  Globe,
  Building,
  Heart,
  Clock,
  Lightbulb
} from 'lucide-react';
import garudadri from  '../Images/garuda.png';
import post1 from '../Images/g-post.png';
import post2 from '../Images/g-post2.png';
import post3 from '../Images/g-post3.png';
import post4 from '../Images/Maa_Garudadri_page_1 (1).png';
import road from '../Images/ES491735.jpg';
import garudadriPdf from '../assets/Maa-Garudadri-1-compressed_1 (1).pdf';

// PURE SILVER Reveal Image Component
const RevealImage = ({ src, alt, className = "" }) => {
  const wrapperRef = useRef();
  const [isRevealed, setIsRevealed] = useState(false);

  useEffect(() => {
    const el = wrapperRef.current;
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setIsRevealed(true);
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.3 }
    );
    if (el) observer.observe(el);
    return () => {
      if (el) observer.unobserve(el);
    };
  }, []);
  
  return (
    <div ref={wrapperRef} className={`relative overflow-hidden ${className}`}>
      <img 
        src={src} 
        alt={alt} 
        className={`w-full h-full object-cover relative z-[1] transition-all duration-[1500ms] ease-out ${
          isRevealed ? 'opacity-100 scale-100 blur-0' : 'opacity-0 scale-110 blur-sm'
        }`}
        style={{ transitionDelay: '800ms' }}
      />
      
      {/* PURE SILVER Gradient Mask */}
      <div 
        className={`absolute top-0 left-0 w-full h-full z-[2] transition-transform duration-[1500ms] ${
          isRevealed ? 'scale-x-0 origin-right' : 'scale-x-100 origin-left'
        }`}
        style={{ 
          transitionTimingFunction: 'cubic-bezier(0.77, 0, 0.175, 1)',
          background: 'linear-gradient(90deg, #C0C0C0 0%, #E8E8E8 25%, #FFFFFF 50%, #E8E8E8 75%, #C0C0C0 100%)'
        }}
      />
      
      {/* Silver Shimmer */}
      <div 
        className={`absolute top-0 left-0 w-full h-full z-[3] transition-all duration-[1500ms] ${
          isRevealed ? 'opacity-0 translate-x-full' : 'opacity-100 translate-x-0'
        }`}
        style={{ 
          transitionDelay: '300ms',
          background: 'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.8) 50%, transparent 100%)',
          transitionTimingFunction: 'cubic-bezier(0.77, 0, 0.175, 1)'
        }}
      />
    </div>
  );
};

const RevealContent = ({ children, className = "", delay = 0 }) => {
  const contentRef = useRef();
  const [isRevealed, setIsRevealed] = useState(false);

  useEffect(() => {
    const el = contentRef.current;
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              setIsRevealed(true);
            }, delay);
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.1 }
    );
    if (el) observer.observe(el);
    return () => {
      if (el) observer.unobserve(el);
    };
  }, [delay]);
  
  return (
    <div 
      ref={contentRef} 
      className={`transition-all duration-1000 ${
        isRevealed ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-[60px]'
      } ${className}`}
      style={{ transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)' }}
    >
      {children}
    </div>
  );
};

const MaaGarudadriPage = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const highlights = [
    { icon: <Home className="w-6 h-6" />, title: 'Villa Plots', subtitle: 'Premium Layouts' },
    { icon: <MapPin className="w-6 h-6" />, title: 'Dandupally', subtitle: 'Nagpur Highway' },
    { icon: <Building2 className="w-6 h-6" />, title: 'Vastu Compliant', subtitle: 'Perfect Design' },
    { icon: <Star className="w-6 h-6" />, title: 'Value-Driven', subtitle: 'Competitive Price' }
  ];

  const features = [
    { icon: <Ruler className="w-8 h-8" />, title: 'Vastu-Compliant Layouts', desc: 'Ensuring harmony and prosperity in every plot' },
    { icon: <ParkingCircle className="w-8 h-8" />, title: 'Wide Roads', desc: 'Modern infrastructure with 40-60 feet roads' },
    { icon: <Zap className="w-8 h-8" />, title: 'Underground Utilities', desc: 'Power supply and drainage systems' },
    { icon: <TreePine className="w-8 h-8" />, title: 'Ample Green Spaces', desc: 'Landscaped parks and gardens' },
    { icon: <Shield className="w-8 h-8" />, title: '24/7 Security', desc: 'Secure gated community with CCTV' },
    { icon: <Droplets className="w-8 h-8" />, title: 'Rainwater Harvesting', desc: 'Environmentally conscious development' },
    { icon: <Activity className="w-8 h-8" />, title: 'Fitness Zones', desc: 'Jogging tracks and outdoor gym' },
    { icon: <Lock className="w-8 h-8" />, title: 'Gated Community', desc: 'Complete peace of mind for residents' }
  ];

  const advantages = [
    { icon: <TrendingUp className="w-10 h-10" />, title: 'Strategic Growth Corridor', desc: 'Connects Hyderabad to major cities, making it ideal for residential and commercial developments' },
    { icon: <Building2 className="w-10 h-10" />, title: 'Infrastructure Boom', desc: 'Government focus on industrial corridors, logistics hubs, and upgraded roads' },
    { icon: <Award className="w-10 h-10" />, title: 'Future-Ready Location', desc: "Dandupally's strategic location ensures high returns on investment" },
    { icon: <Users className="w-10 h-10" />, title: 'Planned Community Living', desc: 'Landscaped parks, fitness zones, and modern amenities for comfortable living' }
  ];

  return (
    <div className="min-h-screen bg-[#f5f3f0] overflow-x-hidden">
      {/* Hero Section */}
      <section className="relative h-screen w-full overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center transition-transform duration-[8000ms] ease-out hover:scale-105"
          style={{ backgroundImage: `url(${garudadri})` }}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>

        <div className="relative z-20 h-full flex items-center">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
            <div className="max-w-3xl">
              <RevealContent delay={100}>
                <div className="inline-block mb-4 sm:mb-6 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 sm:px-6 py-2">
                  <span className="text-white text-xs sm:text-sm font-medium">By Vedamsa - 30 Years of Excellence</span>
                </div>
              </RevealContent>

              <RevealContent delay={200}>
                <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold text-white mb-4 sm:mb-6 leading-tight drop-shadow-2xl">
                  MAA Garudadri
                </h1>
              </RevealContent>
              
              <RevealContent delay={300}>
                <p className="text-xl sm:text-2xl md:text-3xl lg:text-4xl text-white/90 mb-3 sm:mb-4 font-light drop-shadow-lg">
                  Premium Villa Plots
                </p>
              </RevealContent>
              
              <RevealContent delay={400}>
                <p className="text-lg sm:text-xl md:text-2xl text-white/80 mb-6 sm:mb-8 drop-shadow-lg">
                  Dandupally, Nagpur Highway (NH-44)
                </p>
              </RevealContent>

              <RevealContent delay={500}>
                <div className="inline-block bg-white rounded-2xl px-6 sm:px-8 py-3 sm:py-4 mb-8 sm:mb-10 shadow-2xl hover:scale-105 transition-transform duration-300">
                  <p className="text-gray-600 text-xs sm:text-sm mb-1">Northern Growth Corridor</p>
                  <p className="text-xl sm:text-2xl font-bold text-[#2C5F2D]">Hyderabad's Prime Location</p>
                </div>
              </RevealContent>

              <RevealContent delay={600}>
                <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
                  {/* <button className="group bg-white text-gray-900 px-6 sm:px-8 py-3 sm:py-4 rounded-xl font-bold hover:bg-gray-100 transition-all duration-300 shadow-xl hover:shadow-2xl transform hover:-translate-y-1 flex items-center justify-center space-x-2">
                    <Download className="w-4 h-4 sm:w-5 sm:h-5" />
                    <span className="text-sm sm:text-base">Download Brochure</span>
                  </button> */}
                  <button 
  onClick={() => {
    const link = document.createElement('a');
    link.href = garudadriPdf;
    link.download = 'MAA-Garudadri-Brochure.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }}
  className="group bg-white text-gray-900 px-8 sm:px-10 py-4 sm:py-5 rounded-xl font-bold hover:bg-gray-100 transition-all duration-500 shadow-2xl hover:shadow-3xl transform hover:-translate-y-2 text-base sm:text-lg flex items-center justify-center space-x-2 relative overflow-hidden"
>
  <span className="relative z-10 flex items-center space-x-2">
    <Download className="w-5 h-5 sm:w-6 sm:h-6" />
    <span>Download Brochure</span>
  </span>
  <div className="absolute inset-0 bg-gradient-to-r from-[#C0C0C0] to-[#E8E8E8] opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
</button>
                  <a 
                    href="tel:+918885852266"
                    className="bg-transparent border-2 border-white text-white px-6 sm:px-8 py-3 sm:py-4 rounded-xl font-bold hover:bg-white hover:text-gray-900 transition-all duration-500 flex items-center justify-center space-x-2"
                  >
                    <Phone className="w-4 h-4 sm:w-5 sm:h-5" />
                    <span className="text-sm sm:text-base">Schedule Site Visit</span>
                  </a>
                </div>
              </RevealContent>
            </div>
          </div>
        </div>

        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20 animate-bounce">
          <ChevronDown className="w-6 h-6 sm:w-8 sm:h-8 text-white/60" />
        </div>
      </section>

      {/* Quick Highlights Bar */}
      <section className="bg-white py-6 sm:py-8 shadow-lg relative z-30 -mt-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-6">
            {highlights.map((item, index) => (
              <RevealContent key={index} delay={index * 100}>
                <div className="flex items-center space-x-2 sm:space-x-4 p-3 sm:p-4 bg-[#f5f3f0] rounded-xl hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
                  <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-[#2C5F2D] text-white rounded-lg flex items-center justify-center">
                    {item.icon}
                  </div>
                  <div>
                    <p className="font-bold text-gray-900 text-sm sm:text-base">{item.title}</p>
                    <p className="text-xs sm:text-sm text-gray-600">{item.subtitle}</p>
                  </div>
                </div>
              </RevealContent>
            ))}
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-12 sm:py-20 md:py-28 px-4 sm:px-6 lg:px-8 bg-[#f5f3f0]">
  <div className="max-w-7xl mx-auto">
    <div className="text-center mb-12 sm:mb-16">
      <RevealContent>
        <span className="text-xs sm:text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-4 sm:mb-6 block">
          [WELCOME TO]
        </span>
      </RevealContent>
      <RevealContent delay={100}>
        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-4 sm:mb-6">
          Your Dream Villa Awaits
        </h2>
      </RevealContent>
      <RevealContent delay={200}>
        <p className="text-gray-600 text-base sm:text-lg md:text-xl leading-relaxed max-w-4xl mx-auto px-4">
          Welcome to MAA GARUDADRI, a prestigious villa plot project by Vedamsa, a trusted name in Hyderabad's real estate market with over 30 years of expertise. Strategically located in Dandupally, along the thriving Nagpur Highway, MAA GARUDADRI offers the perfect opportunity for those looking to invest in premium real estate within the Northern Growth Corridor of Hyderabad.
        </p>
      </RevealContent>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6">
      <div className="md:col-span-2 relative overflow-hidden rounded-2xl shadow-2xl group aspect-[16/10]">
        <RevealImage 
          src={post3}
          alt="Premium Villa"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
        <div className="absolute bottom-4 sm:bottom-6 left-4 sm:left-6 text-white">
          <p className="text-lg sm:text-2xl font-bold drop-shadow-lg">Premium Villa Plots</p>
          <p className="text-sm sm:text-base text-white/80 drop-shadow-lg">Build Your Dream Home</p>
        </div>
      </div>

      <div className="space-y-4 sm:space-y-6">
        <div className="relative overflow-hidden rounded-2xl shadow-xl group aspect-[16/10]">
          <RevealImage 
            src={post2}
            alt="Gated Community"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/30"></div>
          <div className="absolute bottom-3 sm:bottom-4 left-3 sm:left-4 text-white">
            <p className="text-base sm:text-lg font-bold drop-shadow-lg">Gated Community</p>
          </div>
        </div>
        <div className="relative overflow-hidden rounded-2xl shadow-xl group aspect-[16/9]">
          <RevealImage 
            src="https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=600"
            alt="Green Spaces"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/30"></div>
          <div className="absolute bottom-3 sm:bottom-4 left-3 sm:left-4 text-white">
            <p className="text-base sm:text-lg font-bold drop-shadow-lg">Green Spaces</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

      {/* Why Choose MAA GARUDADRI Section */}
      <section className="py-12 sm:py-20 md:py-28 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 sm:mb-16">
            <RevealContent>
              <span className="text-xs sm:text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-4 sm:mb-6 block">
                [WHY CHOOSE US]
              </span>
            </RevealContent>
            <RevealContent delay={100}>
              <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-4 sm:mb-6">
                Why Choose MAA GARUDADRI?
              </h2>
            </RevealContent>
            <RevealContent delay={200}>
              <h3 className="text-xl sm:text-2xl md:text-3xl font-semibold text-[#2C5F2D] mb-6 sm:mb-8">
                Prime Location: Dandupally, Nagpur Highway
              </h3>
            </RevealContent>
            <RevealContent delay={300}>
              <p className="text-gray-600 text-base sm:text-lg md:text-xl leading-relaxed max-w-4xl mx-auto px-4">
                MAA GARUDADRI is nestled in Dandupally, a rapidly developing region along the Nagpur Highway (NH-44). This area is part of Hyderabad's Northern Growth Corridor, which has become a real estate hotspot due to its excellent connectivity and infrastructure development.
              </p>
            </RevealContent>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 mb-12">
            <RevealContent delay={100}>
              <div className="bg-[#f5f3f0] rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-3">
                <div className="relative h-48 sm:h-56 lg:h-64 overflow-hidden">
                  <RevealImage 
                    src={road}
                    alt="Seamless Connectivity"
                    className="w-full h-full"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#2C5F2D]/80 via-transparent to-transparent"></div>
                  <div className="absolute bottom-3 sm:bottom-4 left-3 sm:left-4">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 bg-white rounded-lg flex items-center justify-center mb-2 shadow-lg">
                      <Globe className="w-5 h-5 sm:w-6 sm:h-6 text-[#2C5F2D]" />
                    </div>
                  </div>
                </div>
                <div className="p-4 sm:p-6">
                  <h4 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">Seamless Connectivity</h4>
                  <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                    Close proximity to ORR, IT hubs, and industrial zones ensuring easy commute and excellent accessibility
                  </p>
                </div>
              </div>
            </RevealContent>

            <RevealContent delay={200}>
              <div className="bg-[#f5f3f0] rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-3">
                <div className="relative h-48 sm:h-56 lg:h-64 overflow-hidden">
                  <RevealImage 
                    src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=600"
                    alt="Urban Amenities"
                    className="w-full h-full"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#2C5F2D]/80 via-transparent to-transparent"></div>
                  <div className="absolute bottom-3 sm:bottom-4 left-3 sm:left-4">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 bg-white rounded-lg flex items-center justify-center mb-2 shadow-lg">
                      <Building className="w-5 h-5 sm:w-6 sm:h-6 text-[#2C5F2D]" />
                    </div>
                  </div>
                </div>
                <div className="p-4 sm:p-6">
                  <h4 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">Access to Urban Amenities</h4>
                  <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                    Educational institutions, hospitals, and shopping centers within easy reach for your convenience
                  </p>
                </div>
              </div>
            </RevealContent>

            <RevealContent delay={300}>
              <div className="bg-[#f5f3f0] rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-3">
                <div className="relative h-48 sm:h-56 lg:h-64 overflow-hidden">
                  <RevealImage 
                    src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600"
                    alt="Future Growth"
                    className="w-full h-full"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#2C5F2D]/80 via-transparent to-transparent"></div>
                  <div className="absolute bottom-3 sm:bottom-4 left-3 sm:left-4">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 bg-white rounded-lg flex items-center justify-center mb-2 shadow-lg">
                      <TrendingUp className="w-5 h-5 sm:w-6 sm:h-6 text-[#2C5F2D]" />
                    </div>
                  </div>
                </div>
                <div className="p-4 sm:p-6">
                  <h4 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">Future Growth Potential</h4>
                  <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                    Proximity to key projects like Pharma City and Aerospace SEZ enhances the value of the region
                  </p>
                </div>
              </div>
            </RevealContent>
          </div>

          <RevealContent delay={400}>
            <div className="text-center">
              <p className="text-gray-700 text-base sm:text-lg md:text-xl font-medium max-w-3xl mx-auto px-4">
                For those looking for villa plots for sale in Nagpur Highway, this location combines urban convenience with serene living.
              </p>
            </div>
          </RevealContent>
        </div>
      </section>

      {/* Vedamsa's Trusted Legacy Section */}
      {/* <section className="py-12 sm:py-20 md:py-28 px-4 sm:px-6 lg:px-8 bg-[#f5f3f0]">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
            <div className="relative overflow-hidden rounded-2xl shadow-2xl group h-[400px] sm:h-[500px] lg:h-[600px] order-2 lg:order-1">
              <RevealImage 
                src={post1}
                alt="Vedamsa Legacy"
                className="w-full h-full"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#2C5F2D]/70 via-transparent to-transparent"></div>
              <div className="absolute bottom-6 sm:bottom-8 left-6 sm:left-8 text-white">
                <Award className="w-8 h-8 sm:w-10 sm:h-10 mb-2 drop-shadow-lg" />
                <p className="text-2xl sm:text-3xl font-bold drop-shadow-lg">30+ Years</p>
                <p className="text-sm sm:text-base text-white/80 drop-shadow-lg">of Excellence & Trust</p>
              </div>
            </div>

            <div className="order-1 lg:order-2">
              <RevealContent>
                <span className="text-xs sm:text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-4 sm:mb-6 block">
                  [TRUSTED DEVELOPER]
                </span>
              </RevealContent>
              <RevealContent delay={100}>
                <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
                  Vedamsa's Trusted Legacy
                </h2>
              </RevealContent>
              <RevealContent delay={200}>
                <p className="text-gray-600 text-base sm:text-lg leading-relaxed mb-6 sm:mb-8">
                  With more than three decades of experience in delivering quality projects, Vedamsa has earned the trust of over 3000 happy customers. When you invest in MAA GARUDADRI, you're choosing a developer known for:
                </p>
              </RevealContent>

              <div className="space-y-3 sm:space-y-4">
                {[
                  { icon: <Award className="w-5 h-5 sm:w-6 sm:h-6 text-[#2C5F2D]" />, title: 'Uncompromising Quality', desc: 'Every project built to the highest standards' },
                  { icon: <CheckCircle className="w-5 h-5 sm:w-6 sm:h-6 text-[#2C5F2D]" />, title: 'Transparent Processes', desc: 'Complete clarity in every transaction' },
                  { icon: <Clock className="w-5 h-5 sm:w-6 sm:h-6 text-[#2C5F2D]" />, title: 'Timely Deliveries', desc: 'Committed to meeting deadlines' },
                  { icon: <Heart className="w-5 h-5 sm:w-6 sm:h-6 text-[#2C5F2D]" />, title: 'Customer-Centric Approach', desc: 'Your satisfaction is our priority' }
                ].map((item, index) => (
                  <RevealContent key={index} delay={300 + (index * 100)}>
                    <div className="flex items-start space-x-3 sm:space-x-4 p-3 sm:p-4 bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
                      <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-[#2C5F2D]/10 rounded-lg flex items-center justify-center">
                        {item.icon}
                      </div>
                      <div>
                        <h4 className="font-bold text-gray-900 mb-1 text-sm sm:text-base">{item.title}</h4>
                        <p className="text-gray-600 text-xs sm:text-sm">{item.desc}</p>
                      </div>
                    </div>
                  </RevealContent>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section> */}
      <section className="py-12 sm:py-20 md:py-28 px-4 sm:px-6 lg:px-8 bg-[#f5f3f0]">
  <div className="max-w-7xl mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      <div className="relative overflow-hidden rounded-2xl shadow-2xl group aspect-square order-2 lg:order-1">
        <RevealImage 
          src={post1}
          alt="Vedamsa Legacy"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#2C5F2D]/70 via-transparent to-transparent"></div>
        <div className="absolute bottom-6 sm:bottom-8 left-6 sm:left-8 text-white">
          <Award className="w-8 h-8 sm:w-10 sm:h-10 mb-2 drop-shadow-lg" />
          <p className="text-2xl sm:text-3xl font-bold drop-shadow-lg">30+ Years</p>
          <p className="text-sm sm:text-base text-white/80 drop-shadow-lg">of Excellence & Trust</p>
        </div>
      </div>

      <div className="order-1 lg:order-2">
        <RevealContent>
          <span className="text-xs sm:text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-4 sm:mb-6 block">
            [TRUSTED DEVELOPER]
          </span>
        </RevealContent>
        <RevealContent delay={100}>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
            Vedamsa's Trusted Legacy
          </h2>
        </RevealContent>
        <RevealContent delay={200}>
          <p className="text-gray-600 text-base sm:text-lg leading-relaxed mb-6 sm:mb-8">
            With more than three decades of experience in delivering quality projects, Vedamsa has earned the trust of over 3000 happy customers. When you invest in MAA GARUDADRI, you're choosing a developer known for:
          </p>
        </RevealContent>

        <div className="space-y-3 sm:space-y-4">
          {[
            { icon: <Award className="w-5 h-5 sm:w-6 sm:h-6 text-[#2C5F2D]" />, title: 'Uncompromising Quality', desc: 'Every project built to the highest standards' },
            { icon: <CheckCircle className="w-5 h-5 sm:w-6 sm:h-6 text-[#2C5F2D]" />, title: 'Transparent Processes', desc: 'Complete clarity in every transaction' },
            { icon: <Clock className="w-5 h-5 sm:w-6 sm:h-6 text-[#2C5F2D]" />, title: 'Timely Deliveries', desc: 'Committed to meeting deadlines' },
            { icon: <Heart className="w-5 h-5 sm:w-6 sm:h-6 text-[#2C5F2D]" />, title: 'Customer-Centric Approach', desc: 'Your satisfaction is our priority' }
          ].map((item, index) => (
            <RevealContent key={index} delay={300 + (index * 100)}>
              <div className="flex items-start space-x-3 sm:space-x-4 p-3 sm:p-4 bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
                <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-[#2C5F2D]/10 rounded-lg flex items-center justify-center">
                  {item.icon}
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1 text-sm sm:text-base">{item.title}</h4>
                  <p className="text-gray-600 text-xs sm:text-sm">{item.desc}</p>
                </div>
              </div>
            </RevealContent>
          ))}
        </div>
      </div>
    </div>
  </div>
</section>

      {/* Premium Villa Plots Section */}
      <section className="py-12 sm:py-20 md:py-28 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
            <div>
              <RevealContent>
                <span className="text-xs sm:text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-4 sm:mb-6 block">
                  [PREMIUM PLOTS]
                </span>
              </RevealContent>
              <RevealContent delay={100}>
                <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
                  Premium Villa Plots with Infinite Possibilities
                </h2>
              </RevealContent>
              <RevealContent delay={200}>
                <p className="text-gray-600 text-base sm:text-lg leading-relaxed mb-6 sm:mb-8">
                  MAA GARUDADRI offers meticulously planned villa plots that are perfect for building your dream home or making a secure investment. Key features include:
                </p>
              </RevealContent>

              <div className="space-y-4 sm:space-y-6">
                {[
                  { icon: <Ruler className="w-5 h-5 sm:w-6 sm:h-6" />, title: 'Vastu-Compliant Layouts', desc: 'Ensuring harmony and prosperity in every aspect of your home' },
                  { icon: <Building2 className="w-5 h-5 sm:w-6 sm:h-6" />, title: 'Modern Infrastructure', desc: 'Wide roads, underground utilities, and ample green spaces' },
                  { icon: <Shield className="w-5 h-5 sm:w-6 sm:h-6" />, title: 'Secure Gated Community', desc: '24/7 security for complete peace of mind' }
                ].map((item, index) => (
                  <RevealContent key={index} delay={300 + (index * 100)}>
                    <div className="flex items-start space-x-3 sm:space-x-4">
                      <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-[#2C5F2D] text-white rounded-lg flex items-center justify-center shadow-lg">
                        {item.icon}
                      </div>
                      <div>
                        <h4 className="font-bold text-gray-900 mb-1 sm:mb-2 text-sm sm:text-base">{item.title}</h4>
                        <p className="text-gray-600 text-xs sm:text-sm">{item.desc}</p>
                      </div>
                    </div>
                  </RevealContent>
                ))}
              </div>

              <RevealContent delay={600}>
                <div className="mt-6 sm:mt-8 p-4 sm:p-6 bg-[#f5f3f0] rounded-xl border-l-4 border-[#2C5F2D]">
                  <p className="text-gray-700 font-medium text-sm sm:text-base">
                    Whether you're seeking to buy villa plots in Nagpur Highway for residential or investment purposes, MAA GARUDADRI offers a future-ready solution.
                  </p>
                </div>
              </RevealContent>
            </div>

            <div className="relative overflow-hidden rounded-2xl shadow-2xl group h-[400px] sm:h-[500px] lg:h-[600px]">
              <RevealImage 
                src={post4}
                alt="Villa Plot Layout"
                className="w-full h-full"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
              <div className="absolute bottom-6 sm:bottom-8 left-6 sm:left-8 right-6 sm:right-8">
                <div className="bg-white/95 backdrop-blur-sm rounded-xl p-4 sm:p-6 shadow-2xl">
                  <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2">Build Your Dream</h3>
                  <p className="text-sm sm:text-base text-gray-600">Flexible plots for custom villa designs</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* What Sets MAA GARUDADRI Apart */}
      <section className="py-12 sm:py-20 md:py-28 px-4 sm:px-6 lg:px-8 bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 sm:mb-16">
            <RevealContent>
              <span className="text-xs sm:text-sm uppercase tracking-[0.3em] text-gray-400 font-medium mb-4 sm:mb-6 block">
                [WHAT SETS US APART]
              </span>
            </RevealContent>
            <RevealContent delay={100}>
              <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 sm:mb-6">
                What Sets MAA GARUDADRI Apart?
              </h2>
            </RevealContent>
            <RevealContent delay={200}>
              <p className="text-gray-300 text-base sm:text-lg md:text-xl max-w-3xl mx-auto px-4">
                Experience the difference with our comprehensive community features and environmentally conscious development
              </p>
            </RevealContent>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 sm:gap-8">
            {[
              { icon: <Users className="w-5 h-5 sm:w-6 sm:h-6 text-white" />, title: '1. Planned Community Living', img: "https://images.unsplash.com/photo-1587582423116-ec07293f0395?w=600", items: ['Landscaped parks, jogging tracks, fitness zones', 'Underground drainage & power supply', '24/7 security services'] },
              { icon: <Lightbulb className="w-5 h-5 sm:w-6 sm:h-6 text-white" />, title: '2. Flexibility in Design', img: "https://images.unsplash.com/photo-1503174971373-b1f69850bded?w=600", items: ['Villa plots allowing you to build your dream home', 'Customizable layouts to suit your needs', 'Freedom to create your perfect living space'] },
              { icon: <TreePine className="w-5 h-5 sm:w-6 sm:h-6 text-white" />, title: '3. Environmentally Conscious', img: "https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?w=600", items: ['Rainwater harvesting systems', 'Energy-efficient lighting throughout', 'Extensive plantation and green cover'] }
            ].map((item, index) => (
              <RevealContent key={index} delay={100 + (index * 100)}>
                <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl overflow-hidden hover:bg-white/10 transition-all duration-500 transform hover:-translate-y-2">
                  <div className="relative h-48 sm:h-56 lg:h-64 overflow-hidden">
                    <RevealImage 
                      src={item.img}
                      alt={item.title}
                      className="w-full h-full"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent"></div>
                    <div className="absolute bottom-3 sm:bottom-4 left-3 sm:left-4">
                      <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#2C5F2D] rounded-lg flex items-center justify-center shadow-lg">
                        {item.icon}
                      </div>
                    </div>
                  </div>
                  <div className="p-4 sm:p-6">
                    <h3 className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4">{item.title}</h3>
                    <ul className="space-y-2 sm:space-y-3 text-gray-300">
                      {item.items.map((text, i) => (
                        <li key={i} className="flex items-start space-x-2">
                          <CheckCircle className="w-4 h-4 sm:w-5 sm:h-5 text-[#4A7C59] flex-shrink-0 mt-0.5" />
                          <span className="text-sm sm:text-base">{text}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </RevealContent>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-12 sm:py-20 md:py-28 px-4 sm:px-6 lg:px-8 bg-[#f5f3f0]">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 sm:mb-16">
            <RevealContent>
              <span className="text-xs sm:text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-4 sm:mb-6 block">
                [PREMIUM FEATURES]
              </span>
            </RevealContent>
            <RevealContent delay={100}>
              <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-4 sm:mb-6">
                World-Class Amenities
              </h2>
            </RevealContent>
            <RevealContent delay={200}>
              <p className="text-gray-600 text-base sm:text-lg md:text-xl leading-relaxed max-w-3xl mx-auto px-4">
                Experience modern living with comprehensive facilities designed for your comfort and convenience
              </p>
            </RevealContent>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
            {features.map((feature, index) => (
              <RevealContent key={index} delay={index * 100}>
                <div className="bg-white p-4 sm:p-6 rounded-xl hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
                  <div className="w-12 h-12 sm:w-16 sm:h-16 bg-[#2C5F2D]/10 text-[#2C5F2D] rounded-xl flex items-center justify-center mb-3 sm:mb-4">
                    {feature.icon}
                  </div>
                  <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">{feature.title}</h3>
                  <p className="text-gray-600 text-xs sm:text-sm">{feature.desc}</p>
                </div>
              </RevealContent>
            ))}
          </div>
        </div>
      </section>

      {/* Investment Advantages */}
      <section className="py-12 sm:py-20 md:py-28 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 sm:mb-16">
            <RevealContent>
              <span className="text-xs sm:text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-4 sm:mb-6 block">
                [WHY INVEST]
              </span>
            </RevealContent>
            <RevealContent delay={100}>
              <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-4 sm:mb-6">
                Why Invest in Villa Plots<br className="hidden sm:block" />on Nagpur Highway?
              </h2>
            </RevealContent>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
            {advantages.map((advantage, index) => (
              <RevealContent key={index} delay={index * 150}>
                <div className="bg-[#f5f3f0] p-6 sm:p-8 rounded-2xl hover:shadow-xl transition-all duration-500 transform hover:-translate-y-2">
                  <div className="w-16 h-16 sm:w-20 sm:h-20 bg-white text-[#2C5F2D] rounded-xl flex items-center justify-center mb-4 sm:mb-6 shadow-md">
                    {advantage.icon}
                  </div>
                  <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4">{advantage.title}</h3>
                  <p className="text-gray-600 leading-relaxed text-sm sm:text-base">{advantage.desc}</p>
                </div>
              </RevealContent>
            ))}
          </div>
        </div>
      </section>

      {/* Location Map */}
      <section className="py-12 sm:py-20 md:py-28 px-4 sm:px-6 lg:px-8 bg-[#f5f3f0]">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8 sm:mb-12">
            <RevealContent>
              <span className="text-xs sm:text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-4 sm:mb-6 block">
                [LOCATION]
              </span>
            </RevealContent>
            <RevealContent delay={100}>
              <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-4 sm:mb-6">
                Find Us Here
              </h2>
            </RevealContent>
          </div>

          <RevealContent delay={200}>
            <div className="relative overflow-hidden rounded-2xl shadow-2xl h-[400px] sm:h-[500px] group">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3804.7441616893837!2d78.19588450000001!3d17.5527712!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcbf12a5f2662cf%3A0xc385d29a5612e332!2sVedamsa%20Infrastructure%20pvt%20ltd!5e0!3m2!1sen!2sus!4v1234567890123!5m2!1sen!2sus"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="w-full h-full"
              ></iframe>
              
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent pointer-events-none"></div>
              <div className="absolute bottom-4 sm:bottom-8 left-4 sm:left-8 right-4 sm:right-8 pointer-events-auto">
                <div className="bg-white/95 backdrop-blur-sm rounded-xl p-4 sm:p-6 shadow-2xl">
                  <div className="flex items-start justify-between flex-col sm:flex-row">
                    <div className="flex-1 mb-4 sm:mb-0">
                      <MapPin className="w-6 h-6 sm:w-8 sm:h-8 text-[#2C5F2D] mb-2" />
                      <p className="text-xl sm:text-2xl font-bold text-gray-900 mb-2">MAA Garudadri, Dandupally</p>
                      <p className="text-sm sm:text-base text-gray-600 mb-4">Nagpur Highway (NH-44), Hyderabad</p>
                    </div>
                  </div>
                  <a 
                    href="https://www.google.com/maps/place/Vedamsa+Infrastructure+pvt+ltd/@17.552771,78.195885,10z"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center space-x-2 bg-[#2C5F2D] text-white px-4 sm:px-6 py-2 sm:py-3 rounded-lg font-semibold hover:bg-[#234a26] transition-all duration-300 shadow-lg hover:shadow-xl text-sm sm:text-base"
                  >
                    <span>Get Directions</span>
                    <ExternalLink className="w-4 h-4 sm:w-5 sm:h-5" />
                  </a>
                </div>
              </div>
            </div>
          </RevealContent>
        </div>
      </section>

      {/* Final CTA */}
      <section className="relative h-screen overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1920')`,
          }}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>

        <div className="relative z-10 h-full flex items-center justify-center px-4 sm:px-6">
          <div className="max-w-4xl mx-auto text-center text-white">
            <RevealContent>
              <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-4 sm:mb-6 drop-shadow-2xl">
                Build Your Future
              </h2>
            </RevealContent>
            <RevealContent delay={100}>
              <p className="text-xl sm:text-2xl md:text-3xl lg:text-4xl text-white mb-3 sm:mb-4 font-light drop-shadow-lg">
                Premium Villa Plots in Dandupally
              </p>
            </RevealContent>
            <RevealContent delay={200}>
              <p className="text-lg sm:text-xl md:text-2xl text-white/90 mb-8 sm:mb-12 drop-shadow-lg">
                Nagpur Highway - Northern Growth Corridor, Hyderabad
              </p>
            </RevealContent>

            <RevealContent delay={300}>
              <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center">
                {/* <button className="bg-white text-gray-900 px-8 sm:px-10 py-4 sm:py-5 rounded-xl font-bold hover:bg-gray-100 transition-all duration-300 shadow-2xl hover:shadow-3xl transform hover:-translate-y-1 text-base sm:text-lg flex items-center justify-center space-x-2">
                  <Download className="w-5 h-5 sm:w-6 sm:h-6" />
                  <span>Download Brochure</span>
                </button> */}
                <button 
  onClick={() => {
    const link = document.createElement('a');
    link.href = garudadriPdf;
    link.download = 'MAA-Garudadri-Brochure.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }}
  className="group bg-white text-gray-900 px-8 sm:px-10 py-4 sm:py-5 rounded-xl font-bold hover:bg-gray-100 transition-all duration-500 shadow-2xl hover:shadow-3xl transform hover:-translate-y-2 text-base sm:text-lg flex items-center justify-center space-x-2 relative overflow-hidden"
>
  <span className="relative z-10 flex items-center space-x-2">
    <Download className="w-5 h-5 sm:w-6 sm:h-6" />
    <span>Download Brochure</span>
  </span>
  <div className="absolute inset-0 bg-gradient-to-r from-[#C0C0C0] to-[#E8E8E8] opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
</button>
                <a 
                  href="tel:+918885852266"
                  className="bg-[#2C5F2D] border-2 border-[#2C5F2D] text-white px-8 sm:px-10 py-4 sm:py-5 rounded-xl font-bold hover:bg-[#234a26] hover:border-[#234a26] transition-all duration-300 shadow-2xl text-base sm:text-lg flex items-center justify-center space-x-2"
                >
                  <Phone className="w-5 h-5 sm:w-6 sm:h-6" />
                  <span className="hidden sm:inline">Call: +91 8885852266</span>
                  <span className="sm:hidden">Call Now</span>
                </a>
              </div>
            </RevealContent>

            <RevealContent delay={400}>
              <div className="mt-8 sm:mt-12 pt-8 sm:pt-12 border-t border-white/30">
                <p className="text-white/90 mb-4 drop-shadow-lg text-sm sm:text-base">Contact Vedamsa Infrastructure</p>
                <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center text-white">
                  <a href="tel:+918885852266" className="flex items-center justify-center space-x-2 hover:text-white/80 transition-colors drop-shadow-lg text-sm sm:text-base">
                    <Phone className="w-4 h-4 sm:w-5 sm:h-5" />
                    <span>+91 8885852266</span>
                  </a>
                  <a href="mailto:Vedamsa@gmail.com" className="flex items-center justify-center space-x-2 hover:text-white/80 transition-colors drop-shadow-lg text-sm sm:text-base">
                    <Mail className="w-4 h-4 sm:w-5 sm:h-5" />
                    <span>Vedamsa@gmail.com</span>
                  </a>
                </div>
              </div>
            </RevealContent>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MaaGarudadriPage;